import { Country } from '../types';

export const africaData: Country[] = [
  {
    "code": "DZ",
    "name": "Algeria",
    "nameAr": "الجزائر",
    "nameFr": "Algeria",
    "cities": [
            {
                  "name": "Ain Temouchent",
                  "nameAr": "عين تموشنت",
                  "nameFr": "Ain Temouchent"
            },
            {
                  "name": "Oran",
                  "nameAr": "وهران",
                  "nameFr": "Oran"
            },
            {
                  "name": "Medea",
                  "nameAr": "المدية",
                  "nameFr": "Médée"
            },
            {
                  "name": "Chlef",
                  "nameAr": "الشلف",
                  "nameFr": "Chlef"
            },
            {
                  "name": "Bechar",
                  "nameAr": "بشار",
                  "nameFr": "Béchar"
            },
            {
                  "name": "Tamanghasset",
                  "nameAr": "تمنراست",
                  "nameFr": "Tamanghasset"
            },
            {
                  "name": "Bejaia",
                  "nameAr": "بجاية",
                  "nameFr": "Bejaia"
            },
            {
                  "name": "Tizi Ouzou",
                  "nameAr": "تيزي وزو",
                  "nameFr": "Tizi Ouzou"
            },
            {
                  "name": "Boumerdes",
                  "nameAr": "بومرداس",
                  "nameFr": "Boumerdes"
            },
            {
                  "name": "Ain Defla",
                  "nameAr": "عين الدفلة",
                  "nameFr": "Ain Defla"
            },
            {
                  "name": "Annaba",
                  "nameAr": "عنابة",
                  "nameFr": "Annaba"
            },
            {
                  "name": "Setif",
                  "nameAr": "سطيف",
                  "nameFr": "Sétif"
            },
            {
                  "name": "Relizane",
                  "nameAr": "غليزان",
                  "nameFr": "Relizane"
            },
            {
                  "name": "Mascara",
                  "nameAr": "ماسكارا",
                  "nameFr": "Mascara"
            },
            {
                  "name": "Mostaganem",
                  "nameAr": "مستغانم",
                  "nameFr": "Mostaganem"
            },
            {
                  "name": "Tiaret",
                  "nameAr": "تيارت",
                  "nameFr": "Tiaret"
            },
            {
                  "name": "Bordj Bou Arreridj",
                  "nameAr": "برج بوعريريج",
                  "nameFr": "Bordj Bou Arreridj"
            },
            {
                  "name": "Tipaza",
                  "nameAr": "تيبازة",
                  "nameFr": "Tipaza"
            },
            {
                  "name": "Bouira",
                  "nameAr": "البويرة",
                  "nameFr": "Bouira"
            },
            {
                  "name": "Tissemsilt",
                  "nameAr": "تيسمسيلت",
                  "nameFr": "Tissemsilt"
            },
            {
                  "name": "Jijel",
                  "nameAr": "جيجل",
                  "nameFr": "Jijel"
            },
            {
                  "name": "Saida",
                  "nameAr": "صيدا",
                  "nameFr": "Saida"
            },
            {
                  "name": "Illizi",
                  "nameAr": "إليزي",
                  "nameFr": "Illizi"
            },
            {
                  "name": "Tlemcen",
                  "nameAr": "تلمسان",
                  "nameFr": "Tlemcen"
            },
            {
                  "name": "Adrar",
                  "nameAr": "أدرار",
                  "nameFr": "Adrar"
            },
            {
                  "name": "Laghouat",
                  "nameAr": "الأغواط",
                  "nameFr": "Laghouat"
            },
            {
                  "name": "Constantine",
                  "nameAr": "قسنطينة",
                  "nameFr": "Constantine"
            },
            {
                  "name": "Khenchela",
                  "nameAr": "خنشلة",
                  "nameFr": "Khenchela"
            },
            {
                  "name": "Batna",
                  "nameAr": "باتنة",
                  "nameFr": "Batna"
            },
            {
                  "name": "Alger",
                  "nameAr": "الجزائر",
                  "nameFr": "Alger"
            },
            {
                  "name": "Skikda",
                  "nameAr": "سكيكدة",
                  "nameFr": "Skikda"
            },
            {
                  "name": "Oum el Bouaghi",
                  "nameAr": "ام البواقي",
                  "nameFr": "Oum el Bouaghi"
            },
            {
                  "name": "Naama",
                  "nameAr": "نعمة",
                  "nameFr": "Naama"
            },
            {
                  "name": "Sidi Bel Abbes",
                  "nameAr": "سيدي بلعباس",
                  "nameFr": "Sidi Bel Abbes"
            },
            {
                  "name": "Mila",
                  "nameAr": "ميلة",
                  "nameFr": "Mila"
            },
            {
                  "name": "Ouargla",
                  "nameAr": "ورقلة",
                  "nameFr": "Ouargla"
            },
            {
                  "name": "Djelfa",
                  "nameAr": "الجلفة",
                  "nameFr": "Djelfa"
            },
            {
                  "name": "El Bayadh",
                  "nameAr": "البيض",
                  "nameFr": "El Bayadh"
            },
            {
                  "name": "Souk Ahras",
                  "nameAr": "سوق أهراس",
                  "nameFr": "Souk Ahras"
            },
            {
                  "name": "El Oued",
                  "nameAr": "الواد",
                  "nameFr": "El Oued"
            },
            {
                  "name": "Blida",
                  "nameAr": "البليدة",
                  "nameFr": "Blida"
            },
            {
                  "name": "Biskra",
                  "nameAr": "بسكرة",
                  "nameFr": "Biskra"
            },
            {
                  "name": "Tebessa",
                  "nameAr": "تبسة",
                  "nameFr": "Tebessa"
            },
            {
                  "name": "Guelma",
                  "nameAr": "قالمة",
                  "nameFr": "Guelma"
            },
            {
                  "name": "Tindouf",
                  "nameAr": "تندوف",
                  "nameFr": "Tindouf"
            },
            {
                  "name": "Ghardaia",
                  "nameAr": "غرداية",
                  "nameFr": "Ghardaia"
            }
      ]
  },
  {
    "code": "AO",
    "name": "Angola",
    "nameAr": "أنغولا",
    "nameFr": "Angola",
    "cities": [
      {
        "name": "Benguela",
        "nameAr": "بنغيلا",
        "nameFr": "Benguela"
      },
      {
        "name": "Uige",
        "nameAr": "يجي",
        "nameFr": "Uige"
      },
      {
        "name": "Bengo",
        "nameAr": "بنغو",
        "nameFr": "Bengo"
      },
      {
        "name": "Cuanza Norte",
        "nameAr": "كوانزا نورتي",
        "nameFr": "Cuanza Norte"
      },
      {
        "name": "Malanje",
        "nameAr": "مالانج",
        "nameFr": "Malanje"
      },
      {
        "name": "Cuanza Sul",
        "nameAr": "كوانزا سول",
        "nameFr": "Cuanza Sul"
      },
      {
        "name": "Huambo",
        "nameAr": "هوامبو",
        "nameFr": "Huambo"
      },
      {
        "name": "Moxico",
        "nameAr": "موكسيكو",
        "nameFr": "Moxico"
      },
      {
        "name": "Cuando Cubango",
        "nameAr": "كواندو كوبانجو",
        "nameFr": "Cuando Cubango"
      },
      {
        "name": "Bie",
        "nameAr": "بيي",
        "nameFr": "Bie"
      },
      {
        "name": "Huila",
        "nameAr": "هويلا",
        "nameFr": "Huila"
      },
      {
        "name": "Lunda Sul",
        "nameAr": "لوندا سول",
        "nameFr": "Lunda Sul"
      },
      {
        "name": "Zaire",
        "nameAr": "زائير",
        "nameFr": "Zaïre"
      },
      {
        "name": "Cunene",
        "nameAr": "كونين",
        "nameFr": "Cunene"
      },
      {
        "name": "Lunda Norte",
        "nameAr": "لوندا نورتي",
        "nameFr": "Lunda Norte"
      },
      {
        "name": "Namibe",
        "nameAr": "ناميبي",
        "nameFr": "Namibe"
      },
      {
        "name": "Cabinda",
        "nameAr": "كابيندا",
        "nameFr": "Cabinda"
      }
    ]
  },
  {
    "code": "BJ",
    "name": "Benin",
    "nameAr": "بنين",
    "nameFr": "Benin",
    "cities": [
      {
        "name": "Plateau",
        "nameAr": "هضبة",
        "nameFr": "Plateau"
      },
      {
        "name": "Collines",
        "nameAr": "التلال",
        "nameFr": "Des collines"
      },
      {
        "name": "Oueme",
        "nameAr": "أويمي",
        "nameFr": "Oueme"
      },
      {
        "name": "Zou",
        "nameAr": "زو",
        "nameFr": "Zou"
      },
      {
        "name": "Atlanyique",
        "nameAr": "Atlanyique",
        "nameFr": "Atlanyique"
      },
      {
        "name": "Borgou",
        "nameAr": "بورغو",
        "nameFr": "Borgou"
      },
      {
        "name": "Mono",
        "nameAr": "مونو",
        "nameFr": "Mono"
      },
      {
        "name": "Kouffo",
        "nameAr": "كوفو",
        "nameFr": "Kouffo"
      },
      {
        "name": "Donga",
        "nameAr": "دونجا",
        "nameFr": "Donga"
      },
      {
        "name": "Littoral",
        "nameAr": "ساحلي",
        "nameFr": "Littoral"
      },
      {
        "name": "Alibori",
        "nameAr": "أليبوري",
        "nameFr": "Alibori"
      },
      {
        "name": "Atakora",
        "nameAr": "أتاكورا",
        "nameFr": "Atakora"
      }
    ]
  },
  {
    "code": "BW",
    "name": "Botswana",
    "nameAr": "بوتسوانا",
    "nameFr": "Botswana",
    "cities": [
      {
        "name": "Central",
        "nameAr": "وسط",
        "nameFr": "Central"
      },
      {
        "name": "South-East",
        "nameAr": "الجنوب الشرقي",
        "nameFr": "Sud-est"
      },
      {
        "name": "North-East",
        "nameAr": "شمال شرق",
        "nameFr": "Nord-est"
      },
      {
        "name": "North-West",
        "nameAr": "الشمال الغربي",
        "nameFr": "Nord Ouest"
      },
      {
        "name": "Ghanzi",
        "nameAr": "غانزي",
        "nameFr": "Ghanzi"
      },
      {
        "name": "Kweneng",
        "nameAr": "كوينينج",
        "nameFr": "Kweneng"
      },
      {
        "name": "Kgalagadi",
        "nameAr": "كغالاغادي",
        "nameFr": "Kgalagadi"
      },
      {
        "name": "Southern",
        "nameAr": "جنوبي",
        "nameFr": "Du sud"
      },
      {
        "name": "Kgatleng",
        "nameAr": "كجاتلينج",
        "nameFr": "Kgatleng"
      }
    ]
  },
  {
    "code": "IO",
    "name": "British Indian Ocean Territory",
    "nameAr": "British Indian Ocean Territory",
    "nameFr": "British Indian Ocean Territory",
    "cities": []
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "nameAr": "بوركينا فاسو",
    "nameFr": "Burkina Faso",
    "cities": [
      {
        "name": "Mouhoun",
        "nameAr": "موهون",
        "nameFr": "Mouhoun"
      },
      {
        "name": "Bam",
        "nameAr": "بام",
        "nameFr": "Bam"
      },
      {
        "name": "Tapoa",
        "nameAr": "تابوا",
        "nameFr": "Tapoa"
      },
      {
        "name": "Soum",
        "nameAr": "سوم",
        "nameFr": "Soum"
      },
      {
        "name": "Leraba",
        "nameAr": "يرابا",
        "nameFr": "Leraba"
      },
      {
        "name": "Noumbiel",
        "nameAr": "نومبيل",
        "nameFr": "Noumbiel"
      },
      {
        "name": "Gnagna",
        "nameAr": "جناجنا",
        "nameFr": "Gnagna"
      },
      {
        "name": "Yatenga",
        "nameAr": "ياتينجا",
        "nameFr": "Yatenga"
      },
      {
        "name": "Banwa",
        "nameAr": "بانوا",
        "nameFr": "Banwa"
      },
      {
        "name": "Poni",
        "nameAr": "بوني",
        "nameFr": "Poni"
      },
      {
        "name": "Loroum",
        "nameAr": "وروم",
        "nameFr": "Loroum"
      },
      {
        "name": "Kouritenga",
        "nameAr": "كوريتنجا",
        "nameFr": "Kouritenga"
      },
      {
        "name": "Tuy",
        "nameAr": "توي",
        "nameFr": "Tuy"
      },
      {
        "name": "Kossi",
        "nameAr": "كوسي",
        "nameFr": "Kossi"
      },
      {
        "name": "Passore",
        "nameAr": "باسور",
        "nameFr": "Passore"
      },
      {
        "name": "Kenedougou",
        "nameAr": "كيندوجو",
        "nameFr": "Kénédougou"
      },
      {
        "name": "Bale",
        "nameAr": "بالة",
        "nameFr": "Balle"
      },
      {
        "name": "Bougouriba",
        "nameAr": "بوغوريبا",
        "nameFr": "Bougouriba"
      },
      {
        "name": "Houet",
        "nameAr": "هويت",
        "nameFr": "Houet"
      },
      {
        "name": "Gourma",
        "nameAr": "جورما",
        "nameFr": "Gourma"
      },
      {
        "name": "Namentenga",
        "nameAr": "نامنتنجا",
        "nameFr": "Namentenga"
      },
      {
        "name": "Sanmatenga",
        "nameAr": "سانماتينغا",
        "nameFr": "Sanmatenga"
      },
      {
        "name": "Ioba",
        "nameAr": "إيوبا",
        "nameFr": "Ioba"
      },
      {
        "name": "Ganzourgou",
        "nameAr": "غانزورغو",
        "nameFr": "Ganzourgou"
      },
      {
        "name": "Naouri",
        "nameAr": "الناعوري",
        "nameFr": "Naouri"
      },
      {
        "name": "Boulkiemde",
        "nameAr": "بولكيمد",
        "nameFr": "Boulkiemde"
      },
      {
        "name": "Zoundweogo",
        "nameAr": "زوندويجو",
        "nameFr": "Zoundweogo"
      },
      {
        "name": "Zondoma",
        "nameAr": "زوندوما",
        "nameFr": "Zondoma"
      },
      {
        "name": "Komoe",
        "nameAr": "Komoe",
        "nameFr": "Komoe"
      },
      {
        "name": "Yagha",
        "nameAr": "ياغا",
        "nameFr": "Yagha"
      },
      {
        "name": "Komondjari",
        "nameAr": "كوموندجاري",
        "nameFr": "Komondjari"
      },
      {
        "name": "Sourou",
        "nameAr": "سورو",
        "nameFr": "Sourou"
      },
      {
        "name": "Nayala",
        "nameAr": "نايالا",
        "nameFr": "Nayala"
      },
      {
        "name": "Sissili",
        "nameAr": "سيسيلي",
        "nameFr": "Sissili"
      },
      {
        "name": "Sanguie",
        "nameAr": "سانجوي",
        "nameFr": "Sanguie"
      },
      {
        "name": "Oudalan",
        "nameAr": "أودالان",
        "nameFr": "Oudalan"
      },
      {
        "name": "Koulpelogo",
        "nameAr": "كولبيلوجو",
        "nameFr": "Koulpelogo"
      },
      {
        "name": "Ziro",
        "nameAr": "زيرو",
        "nameFr": "Ziro"
      },
      {
        "name": "Kourweogo",
        "nameAr": "كورويجو",
        "nameFr": "Kourweogo"
      },
      {
        "name": "Oubritenga",
        "nameAr": "أوبريتنغا",
        "nameFr": "Oubritenga"
      },
      {
        "name": "Seno",
        "nameAr": "سينو",
        "nameFr": "Seno"
      },
      {
        "name": "Bazega",
        "nameAr": "بازيجا",
        "nameFr": "Bazega"
      },
      {
        "name": "Kadiogo",
        "nameAr": "كاديوغو",
        "nameFr": "Kadiogo"
      },
      {
        "name": "Kompienga",
        "nameAr": "كومبينغا",
        "nameFr": "Kompienga"
      },
      {
        "name": "Boulgou",
        "nameAr": "بولغو",
        "nameFr": "Boulgou"
      }
    ]
  },
  {
    "code": "BI",
    "name": "Burundi",
    "nameAr": "بوروندي",
    "nameFr": "Burundi",
    "cities": [
      {
        "name": "Karuzi",
        "nameAr": "كاروزي",
        "nameFr": "Karuzi"
      },
      {
        "name": "Ruyigi",
        "nameAr": "رويجي",
        "nameFr": "Ruyigi"
      },
      {
        "name": "Bubanza",
        "nameAr": "بوبانزا",
        "nameFr": "Bubanza"
      },
      {
        "name": "Bururi",
        "nameAr": "بوروري",
        "nameFr": "Bururi"
      },
      {
        "name": "Makamba",
        "nameAr": "ماكامبا",
        "nameFr": "Makamba"
      },
      {
        "name": "Kayanza",
        "nameAr": "كاينزا",
        "nameFr": "Kayanza"
      },
      {
        "name": "Rutana",
        "nameAr": "روتانا",
        "nameFr": "Rutana"
      },
      {
        "name": "Muyinga",
        "nameAr": "مويينغا",
        "nameFr": "Muyinga"
      },
      {
        "name": "Cibitoke",
        "nameAr": "سيبيتوكييه",
        "nameFr": "Cibitoke"
      },
      {
        "name": "Gitega",
        "nameAr": "غيتيغا",
        "nameFr": "Gitega"
      },
      {
        "name": "Cankuzo",
        "nameAr": "كانكوزا",
        "nameFr": "Cankuzo"
      },
      {
        "name": "Bujumbura",
        "nameAr": "بوجمبورا",
        "nameFr": "Bujumbura"
      },
      {
        "name": "Ngozi",
        "nameAr": "نغوزي",
        "nameFr": "Ngozi"
      },
      {
        "name": "Kirundo",
        "nameAr": "كيروندو",
        "nameFr": "Kirundo"
      }
    ]
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "nameAr": "الكاميرون",
    "nameFr": "Cameroon",
    "cities": [
      {
        "name": "Est",
        "nameAr": "EST",
        "nameFr": "Est"
      },
      {
        "name": "Adamaoua",
        "nameAr": "أداماوا",
        "nameFr": "Adamaoua"
      },
      {
        "name": "Centre",
        "nameAr": "مركز",
        "nameFr": "Centre"
      },
      {
        "name": "Sud",
        "nameAr": "سود",
        "nameFr": "Sud"
      },
      {
        "name": "Nord-Ouest",
        "nameAr": "الإقليم الشمالي الغربي",
        "nameFr": "Nord-Ouest"
      },
      {
        "name": "Extreme-Nord",
        "nameAr": "المتطرف نور",
        "nameFr": "Extreme-Nord"
      },
      {
        "name": "Sud-Ouest",
        "nameAr": "الإقليم الجنوبي الغربي",
        "nameFr": "Sud-Ouest"
      },
      {
        "name": "Littoral",
        "nameAr": "ساحلي",
        "nameFr": "Littoral"
      },
      {
        "name": "Nord",
        "nameAr": "نورد",
        "nameFr": "Nord"
      },
      {
        "name": "Ouest",
        "nameAr": "كويست",
        "nameFr": "Ouest"
      }
    ]
  },
  {
    "code": "CV",
    "name": "Cape Verde",
    "nameAr": "الرأس الأخضر",
    "nameFr": "Cape Verde",
    "cities": [
      {
        "name": "Sao Domingos",
        "nameAr": "ساو دومينغوس",
        "nameFr": "Sao Domingos"
      }
    ]
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "nameAr": "جمهورية أفريقيا الوسطى",
    "nameFr": "Central African Republic",
    "cities": [
      {
        "name": "Nana-Mambere",
        "nameAr": "نانا مامبيري",
        "nameFr": "Nana-Mambere"
      },
      {
        "name": "Ouaka",
        "nameAr": "أواكا",
        "nameFr": "Ouaka"
      },
      {
        "name": "Haute-Kotto",
        "nameAr": "كوتو العليا",
        "nameFr": "Haute-Kotto"
      },
      {
        "name": "Sangha-Mbaere",
        "nameAr": "سانغا مباري",
        "nameFr": "Sangha-Mbaere"
      },
      {
        "name": "Bamingui-Bangoran",
        "nameAr": "بامينغي-بانغوران",
        "nameFr": "Bamingui-Bangoran"
      },
      {
        "name": "Mbomou",
        "nameAr": "مبومو",
        "nameFr": "Mbomou"
      },
      {
        "name": "Basse-Kotto",
        "nameAr": "باس كوتو",
        "nameFr": "Basse-Kotto"
      },
      {
        "name": "Kemo",
        "nameAr": "كيمو",
        "nameFr": "Kemo"
      },
      {
        "name": "Haut-Mbomou",
        "nameAr": "هوت مبومو",
        "nameFr": "Haut-Mbomou"
      },
      {
        "name": "Ouham-Pende",
        "nameAr": "أوهام بندي",
        "nameFr": "Ouham-Pende"
      },
      {
        "name": "Ouham",
        "nameAr": "أوهام",
        "nameFr": "Ouham"
      },
      {
        "name": "Ombella-Mpoko",
        "nameAr": "أومبلا مبوكي",
        "nameFr": "Ombella-Mpoko"
      },
      {
        "name": "Cuvette-Ouest",
        "nameAr": "كفيت-كويست",
        "nameFr": "Cuvette-Ouest"
      },
      {
        "name": "Mambere-Kadei",
        "nameAr": "مامبري كادي",
        "nameFr": "Mambere-Kadei"
      },
      {
        "name": "Lobaye",
        "nameAr": "وباي",
        "nameFr": "Lobaye"
      },
      {
        "name": "Nana-Grebizi",
        "nameAr": "نانا غريبيزي",
        "nameFr": "Nana-Grebizi"
      },
      {
        "name": "Bangui",
        "nameAr": "بانغي",
        "nameFr": "Bangui"
      }
    ]
  },
  {
    "code": "TD",
    "name": "Chad",
    "nameAr": "تشاد",
    "nameFr": "Chad",
    "cities": [
            {
                  "name": "Bahr el Gazel",
                  "nameAr": "Bahr El Gazel",
                  "nameFr": "Bahr el Gazel"
            },
            {
                  "name": "Batha",
                  "nameAr": "Batha",
                  "nameFr": "Batha"
            },
            {
                  "name": "Borkou",
                  "nameAr": "Borkou",
                  "nameFr": "Borkou"
            },
            {
                  "name": "Chari-Baguirmi",
                  "nameAr": "Chari-baguirmi",
                  "nameFr": "Chari-Baguirmi"
            },
            {
                  "name": "Ennedi-Est",
                  "nameAr": "Ennedi-Est",
                  "nameFr": "Ennedi-Est"
            },
            {
                  "name": "Ennedi-Ouest",
                  "nameAr": "Ennedi-Ouest",
                  "nameFr": "Ennedi-Ouest"
            },
            {
                  "name": "Guéra",
                  "nameAr": "Guéra",
                  "nameFr": "Guéra"
            },
            {
                  "name": "Hadjer-Lamis",
                  "nameAr": "Hadjer-lamis",
                  "nameFr": "Hadjer-Lamis"
            },
            {
                  "name": "Kanem",
                  "nameAr": "Kanem",
                  "nameFr": "Kanem"
            },
            {
                  "name": "Lac",
                  "nameAr": "Lac",
                  "nameFr": "Lac"
            },
            {
                  "name": "Logone Occidental",
                  "nameAr": "Logone Occidental",
                  "nameFr": "Logone Occidental"
            },
            {
                  "name": "Logone Oriental",
                  "nameAr": "Logone Oriental",
                  "nameFr": "Logone Oriental"
            },
            {
                  "name": "Mandoul",
                  "nameAr": "Mandall",
                  "nameFr": "Mandoul"
            },
            {
                  "name": "Mayo-Kebbi Est",
                  "nameAr": "Micha-cube EST",
                  "nameFr": "Mayo-Kebbi Est"
            },
            {
                  "name": "Mayo-Kebbi Ouest",
                  "nameAr": "Mayo-kebbi Oust",
                  "nameFr": "Mayo-Kebbi Ouest"
            },
            {
                  "name": "Moyen-Chari",
                  "nameAr": "Moyen-Chari",
                  "nameFr": "Moyen-Chari"
            },
            {
                  "name": "N'Djamena",
                  "nameAr": "N'Djamena",
                  "nameFr": "N'Djamena"
            },
            {
                  "name": "Ouaddaï",
                  "nameAr": "Ouaddaï",
                  "nameFr": "Ouaddaï"
            },
            {
                  "name": "Salamat",
                  "nameAr": "Merci",
                  "nameFr": "Salamat"
            },
            {
                  "name": "Sila",
                  "nameAr": "Ils sont",
                  "nameFr": "Sila"
            },
            {
                  "name": "Tandjilé",
                  "nameAr": "Dentaire",
                  "nameFr": "Tandjilé"
            },
            {
                  "name": "Tibesti",
                  "nameAr": "Tibesti",
                  "nameFr": "Tibesti"
            },
            {
                  "name": "Wadi Fira",
                  "nameAr": "Wadi Fira",
                  "nameFr": "Wadi Fira"
            }
      ]
  },
  {
    "code": "KM",
    "name": "Comoros",
    "nameAr": "جزر القمر",
    "nameFr": "Comoros",
    "cities": [
            {
                  "name": "Anjouan",
                  "nameAr": "Anjouan",
                  "nameFr": "Anjouan"
            },
            {
                  "name": "Grande Comore",
                  "nameAr": "قادم طويل القامة",
                  "nameFr": "Grande Comore"
            },
            {
                  "name": "Mohéli",
                  "nameAr": "موهلي",
                  "nameFr": "Mohéli"
            }
      ]
  },
  {
    "code": "CG",
    "name": "Congo",
    "nameAr": "الكونغو",
    "nameFr": "Congo",
    "cities": [
      {
        "name": "Plateaux",
        "nameAr": "الهضاب",
        "nameFr": "Plateaux"
      },
      {
        "name": "Pool",
        "nameAr": "حوض السباحة",
        "nameFr": "bassin"
      },
      {
        "name": "Sangha",
        "nameAr": "سانغا",
        "nameFr": "Sangha"
      },
      {
        "name": "Lekoumou",
        "nameAr": "يكومو",
        "nameFr": "Lekoumou"
      },
      {
        "name": "Likouala",
        "nameAr": "يكوالا",
        "nameFr": "Likouala"
      },
      {
        "name": "Kouilou",
        "nameAr": "كويلو",
        "nameFr": "Kouilou"
      },
      {
        "name": "Niari",
        "nameAr": "نياري",
        "nameFr": "Niari"
      },
      {
        "name": "Bouenza",
        "nameAr": "بوينزا",
        "nameFr": "Bouenza"
      },
      {
        "name": "Brazzaville",
        "nameAr": "برازافيل",
        "nameFr": "Brazzaville"
      },
      {
        "name": "Cuvette-Ouest",
        "nameAr": "كفيت-كويست",
        "nameFr": "Cuvette-Ouest"
      },
      {
        "name": "Cuvette",
        "nameAr": "كفيت",
        "nameFr": "Cuvette"
      }
    ]
  },
  {
    "code": "CI",
    "name": "Cote D'Ivoire (Ivory Coast)",
    "nameAr": "ساحل العاج",
    "nameFr": "Cote D'Ivoire (Ivory Coast)",
    "cities": [
      {
        "name": "Abidjan",
        "nameAr": "",
        "nameFr": "Abidjan"
      },
      {
        "name": "Agnéby",
        "nameAr": "",
        "nameFr": "Agnéby"
      },
      {
        "name": "Bafing",
        "nameAr": "",
        "nameFr": "Bafing"
      },
      {
        "name": "Bas-Sassandra",
        "nameAr": "",
        "nameFr": "Bas-Sassandra"
      },
      {
        "name": "Comoé",
        "nameAr": "",
        "nameFr": "Comoé"
      },
      {
        "name": "Denguélé",
        "nameAr": "",
        "nameFr": "Denguélé"
      },
      {
        "name": "Dix-Huit Montagnes",
        "nameAr": "",
        "nameFr": "Dix-Huit Montagnes"
      },
      {
        "name": "Fromager",
        "nameAr": "",
        "nameFr": "Fromager"
      },
      {
        "name": "Gôh-Djiboua",
        "nameAr": "",
        "nameFr": "Gôh-Djiboua"
      },
      {
        "name": "Haut-Sassandra",
        "nameAr": "",
        "nameFr": "Haut-Sassandra"
      },
      {
        "name": "Lacs",
        "nameAr": "",
        "nameFr": "Lacs"
      },
      {
        "name": "Lagunes",
        "nameAr": "",
        "nameFr": "Lagunes"
      },
      {
        "name": "Marahoué",
        "nameAr": "",
        "nameFr": "Marahoué"
      },
      {
        "name": "Montagnes",
        "nameAr": "",
        "nameFr": "Montagnes"
      },
      {
        "name": "Moyen-Cavally",
        "nameAr": "",
        "nameFr": "Moyen-Cavally"
      },
      {
        "name": "Moyen-Comoé",
        "nameAr": "",
        "nameFr": "Moyen-Comoé"
      },
      {
        "name": "N'zi-Comoé",
        "nameAr": "",
        "nameFr": "N'zi-Comoé"
      },
      {
        "name": "Sassandra-Marahoué",
        "nameAr": "",
        "nameFr": "Sassandra-Marahoué"
      },
      {
        "name": "Savanes",
        "nameAr": "",
        "nameFr": "Savanes"
      },
      {
        "name": "Sud-Bandama",
        "nameAr": "",
        "nameFr": "Sud-Bandama"
      },
      {
        "name": "Sud-Comoé",
        "nameAr": "",
        "nameFr": "Sud-Comoé"
      },
      {
        "name": "Vallée du Bandama",
        "nameAr": "",
        "nameFr": "Vallée du Bandama"
      },
      {
        "name": "Woroba",
        "nameAr": "",
        "nameFr": "Woroba"
      },
      {
        "name": "Worodougou",
        "nameAr": "",
        "nameFr": "Worodougou"
      },
      {
        "name": "Yamoussoukro",
        "nameAr": "",
        "nameFr": "Yamoussoukro"
      },
      {
        "name": "Zanzan",
        "nameAr": "",
        "nameFr": "Zanzan"
      }
    ]
  },
  {
    "code": "CD",
    "name": "Democratic Republic of the Congo",
    "nameAr": "جمهورية الكونغو الديمقراطية",
    "nameFr": "Democratic Republic of the Congo",
    "cities": [
      {
        "name": "Equateur",
        "nameAr": "خط الاستواء",
        "nameFr": "Équateur"
      },
      {
        "name": "Orientale",
        "nameAr": "الشرقية",
        "nameFr": "Orientale"
      },
      {
        "name": "Nord-Kivu",
        "nameAr": "شمال كيفو",
        "nameFr": "Nord-Kivu"
      },
      {
        "name": "Maniema",
        "nameAr": "مانيما",
        "nameFr": "Maniema"
      },
      {
        "name": "Bandundu",
        "nameAr": "باندوندو",
        "nameFr": "Bandundu"
      },
      {
        "name": "Katanga",
        "nameAr": "كاتانغا",
        "nameFr": "Katanga"
      },
      {
        "name": "Sud-Kivu",
        "nameAr": "جنوب كيفو",
        "nameFr": "Sud-Kivu"
      },
      {
        "name": "Bas-Congo",
        "nameAr": "الكونغو السفلى",
        "nameFr": "Bas-Congo"
      },
      {
        "name": "Kasai-Oriental",
        "nameAr": "كاساي الشرقية",
        "nameFr": "Kasai-Oriental"
      },
      {
        "name": "Kinshasa",
        "nameAr": "كينشاسا",
        "nameFr": "Kinshasa"
      }
    ]
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "nameAr": "جيبوتي",
    "nameFr": "Djibouti",
    "cities": [
      {
        "name": "Ali Sabieh",
        "nameAr": "علي صبيح",
        "nameFr": "Ali Sabieh"
      },
      {
        "name": "Tadjoura",
        "nameAr": "تاجورا",
        "nameFr": "Tadjoura"
      },
      {
        "name": "Obock",
        "nameAr": "أوبوك",
        "nameFr": "Obock"
      },
      {
        "name": "Arta",
        "nameAr": "أرتا",
        "nameFr": "Arta"
      },
      {
        "name": "Dikhil",
        "nameAr": "دخيل",
        "nameFr": "Dikhil"
      }
    ]
  },
  {
    "code": "EG",
    "name": "Egypt",
    "nameAr": "مصر",
    "nameFr": "Egypt",
    "cities": [
            {
                  "name": "Cairo",
                  "nameAr": "القاهرة",
                  "nameFr": "Le Caire"
            },
            {
                  "name": "Alexandria",
                  "nameAr": "الإسكندرية",
                  "nameFr": "Alexandrie"
            },
            {
                  "name": "Giza",
                  "nameAr": "الجيزة",
                  "nameFr": "Gizeh"
            },
            {
                  "name": "Port Said",
                  "nameAr": "بورسعيد",
                  "nameFr": "Port-Saïd"
            },
            {
                  "name": "Suez",
                  "nameAr": "السويس",
                  "nameFr": "Suez"
            },
            {
                  "name": "Ismailia",
                  "nameAr": "الإسماعيلية",
                  "nameFr": "Ismaïlia"
            },
            {
                  "name": "Aswan",
                  "nameAr": "أسوان",
                  "nameFr": "Assouan"
            },
            {
                  "name": "Asyut",
                  "nameAr": "أسيوط",
                  "nameFr": "Assiout"
            },
            {
                  "name": "Beheira",
                  "nameAr": "البحيرة",
                  "nameFr": "Beheira"
            },
            {
                  "name": "Beni Suef",
                  "nameAr": "بني سويف",
                  "nameFr": "Beni Suef"
            },
            {
                  "name": "Dakahlia",
                  "nameAr": "الدقهلية",
                  "nameFr": "Dakahlia"
            },
            {
                  "name": "Damietta",
                  "nameAr": "دمياط",
                  "nameFr": "Damiette"
            },
            {
                  "name": "Faiyum",
                  "nameAr": "الفيوم",
                  "nameFr": "Faiyoum"
            },
            {
                  "name": "Gharbia",
                  "nameAr": "الغربية",
                  "nameFr": "Gharbia"
            },
            {
                  "name": "Kafr El Sheikh",
                  "nameAr": "كفر الشيخ",
                  "nameFr": "Kafr El Sheikh"
            },
            {
                  "name": "Luxor",
                  "nameAr": "الأقصر",
                  "nameFr": "Louxor"
            },
            {
                  "name": "Matrouh",
                  "nameAr": "مطروح",
                  "nameFr": "Matrouh"
            },
            {
                  "name": "Minya",
                  "nameAr": "المنيا",
                  "nameFr": "Minya"
            },
            {
                  "name": "Monufia",
                  "nameAr": "المنوفية",
                  "nameFr": "Monufia"
            },
            {
                  "name": "New Valley",
                  "nameAr": "الوادي الجديد",
                  "nameFr": "Nouvelle Vallée"
            },
            {
                  "name": "North Sinai",
                  "nameAr": "شمال سيناء",
                  "nameFr": "Sinaï du Nord"
            },
            {
                  "name": "Qalyubia",
                  "nameAr": "القليوبية",
                  "nameFr": "Qalyubia"
            },
            {
                  "name": "Qena",
                  "nameAr": "قنا",
                  "nameFr": "Qena"
            },
            {
                  "name": "Red Sea",
                  "nameAr": "البحر الأحمر",
                  "nameFr": "Mer Rouge"
            },
            {
                  "name": "Sharqia",
                  "nameAr": "الشرقية",
                  "nameFr": "Sharqia"
            },
            {
                  "name": "Sohag",
                  "nameAr": "سوهاج",
                  "nameFr": "Sohag"
            },
            {
                  "name": "South Sinai",
                  "nameAr": "جنوب سيناء",
                  "nameFr": "Sinaï du Sud"
            }
      ]
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "nameAr": "غينيا الاستوائية",
    "nameFr": "Equatorial Guinea",
    "cities": [
            {
                  "name": "Annobón",
                  "nameAr": "Annobón",
                  "nameFr": "Annobón"
            },
            {
                  "name": "Bioko Norte",
                  "nameAr": "Bioko norte",
                  "nameFr": "Bioko Norte"
            },
            {
                  "name": "Bioko Sur",
                  "nameAr": "Bioko sur",
                  "nameFr": "Bioko Sur"
            },
            {
                  "name": "Centro Sur",
                  "nameAr": "Centro Sur",
                  "nameFr": "Centro Sur"
            },
            {
                  "name": "Insular",
                  "nameAr": "Insular",
                  "nameFr": "Insular"
            },
            {
                  "name": "Kié-Ntem",
                  "nameAr": "A quien hice",
                  "nameFr": "Kié-Ntem"
            },
            {
                  "name": "Litoral",
                  "nameAr": "Costero",
                  "nameFr": "Litoral"
            },
            {
                  "name": "Río Muni",
                  "nameAr": "Río Muni",
                  "nameFr": "Río Muni"
            },
            {
                  "name": "Wele-Nzas",
                  "nameAr": "Wele-nza",
                  "nameFr": "Wele-Nzas"
            }
      ]
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "nameAr": "إريتريا",
    "nameFr": "Eritrea",
    "cities": [
            {
                  "name": "Bengo",
                  "nameAr": "Porta-malas",
                  "nameFr": "Bengo"
            },
            {
                  "name": "Benguela",
                  "nameAr": "Benguela",
                  "nameFr": "Benguela"
            },
            {
                  "name": "Bié",
                  "nameAr": "Bié",
                  "nameFr": "Bié"
            },
            {
                  "name": "Cabinda",
                  "nameAr": "Cabinda",
                  "nameFr": "Cabinda"
            },
            {
                  "name": "Cuando Cubango",
                  "nameAr": "Quando Cubango",
                  "nameFr": "Cuando Cubango"
            },
            {
                  "name": "Cuanza",
                  "nameAr": "Quanza",
                  "nameFr": "Cuanza"
            },
            {
                  "name": "Cuanza Norte",
                  "nameAr": "Cuanza Norte",
                  "nameFr": "Cuanza Norte"
            },
            {
                  "name": "Cunene",
                  "nameAr": "Cunene",
                  "nameFr": "Cunene"
            },
            {
                  "name": "Huambo",
                  "nameAr": "Huambo",
                  "nameFr": "Huambo"
            },
            {
                  "name": "Huíla",
                  "nameAr": "Huíla",
                  "nameFr": "Huíla"
            },
            {
                  "name": "Luanda",
                  "nameAr": "Luanda",
                  "nameFr": "Luanda"
            },
            {
                  "name": "Lunda Norte",
                  "nameAr": "Lunda Norte",
                  "nameFr": "Lunda Norte"
            },
            {
                  "name": "Lunda Sul",
                  "nameAr": "Lunda Sul",
                  "nameFr": "Lunda Sul"
            },
            {
                  "name": "Malanje",
                  "nameAr": "Malanje",
                  "nameFr": "Malanje"
            },
            {
                  "name": "Moxico",
                  "nameAr": "Moxico",
                  "nameFr": "Moxico"
            },
            {
                  "name": "Uíge",
                  "nameAr": "Uíge",
                  "nameFr": "Uíge"
            },
            {
                  "name": "Zaire",
                  "nameAr": "Zaire",
                  "nameFr": "Zaire"
            }
      ]
  },
  {
    "code": "SZ",
    "name": "Eswatini",
    "nameAr": "إسواتيني",
    "nameFr": "Eswatini",
    "cities": [
            {
                  "name": "Hhohho",
                  "nameAr": "Hhohho",
                  "nameFr": "Hhohho"
            },
            {
                  "name": "Lubombo",
                  "nameAr": "Bitch",
                  "nameFr": "Lubombo"
            },
            {
                  "name": "Manzini",
                  "nameAr": "Chic",
                  "nameFr": "Manzini"
            },
            {
                  "name": "Shiselweni",
                  "nameAr": "Suspend",
                  "nameFr": "Shiselweni"
            }
      ]
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "nameAr": "إثيوبيا",
    "nameFr": "Ethiopia",
    "cities": [
            {
                  "name": "Addis Ababa",
                  "nameAr": "አዲስ አበባ",
                  "nameFr": "Addis Ababa"
            },
            {
                  "name": "Afar",
                  "nameAr": "አፋር",
                  "nameFr": "Afar"
            },
            {
                  "name": "Amhara",
                  "nameAr": "አማራ",
                  "nameFr": "Amhara"
            },
            {
                  "name": "Benishangul-Gumuz",
                  "nameAr": "ቤኒሻል-ጉሙዝ",
                  "nameFr": "Benishangul-Gumuz"
            },
            {
                  "name": "Dire Dawa",
                  "nameAr": "አዝናኝ",
                  "nameFr": "Dire Dawa"
            },
            {
                  "name": "Gambela",
                  "nameAr": "ጋምቤላ",
                  "nameFr": "Gambela"
            },
            {
                  "name": "Harari",
                  "nameAr": "ሐረሪ",
                  "nameFr": "Harari"
            },
            {
                  "name": "Oromia",
                  "nameAr": "Oromia",
                  "nameFr": "Oromia"
            },
            {
                  "name": "Somali",
                  "nameAr": "ሶማሊ",
                  "nameFr": "Somali"
            },
            {
                  "name": "Southern Nations, Nationalities, and Peoples'",
                  "nameAr": "የደቡብ ብሔሮች, ብሔረሰቦች እና ሕዝቦች '",
                  "nameFr": "Southern Nations, Nationalities, and Peoples'"
            },
            {
                  "name": "Tigray",
                  "nameAr": "ትግራይ",
                  "nameFr": "Tigray"
            }
      ]
  },
  {
    "code": "TF",
    "name": "French Southern Territories",
    "nameAr": "French Southern Territories",
    "nameFr": "French Southern Territories",
    "cities": []
  },
  {
    "code": "GA",
    "name": "Gabon",
    "nameAr": "الغابون",
    "nameFr": "Gabon",
    "cities": [
      {
        "name": "Estuaire",
        "nameAr": "إيستوير",
        "nameFr": "Estuaire"
      },
      {
        "name": "Woleu-Ntem",
        "nameAr": "ليو نتيم",
        "nameFr": "Woleu-Ntem"
      },
      {
        "name": "Moyen-Ogooue",
        "nameAr": "موين-أوغوي",
        "nameFr": "Moyen-Ogooué"
      },
      {
        "name": "Ogooue-Maritime",
        "nameAr": "أوغوي البحرية",
        "nameFr": "Ogooue-Maritime"
      },
      {
        "name": "Ogooue-Lolo",
        "nameAr": "أوغوي لولو",
        "nameFr": "Ogooué-Lolo"
      },
      {
        "name": "Ogooue-Ivindo",
        "nameAr": "أوجوي إيفندو",
        "nameFr": "Ogooué-Ivindo"
      },
      {
        "name": "Haut-Ogooue",
        "nameAr": "أوت أوغوي",
        "nameFr": "Haut-Ogooué"
      },
      {
        "name": "Ngounie",
        "nameAr": "نغوني",
        "nameFr": "Ngounie"
      },
      {
        "name": "Nyanga",
        "nameAr": "النيانغا",
        "nameFr": "Nyanga"
      }
    ]
  },
  {
    "code": "GH",
    "name": "Ghana",
    "nameAr": "غانا",
    "nameFr": "Ghana",
    "cities": [
            {
                  "name": "Estuaire",
                  "nameAr": "Estuaire",
                  "nameFr": "Estuaire"
            },
            {
                  "name": "Haut-Ogooué",
                  "nameAr": "Haut-Ogooué",
                  "nameFr": "Haut-Ogooué"
            },
            {
                  "name": "Moyen-Ogooué",
                  "nameAr": "Moyen-Ogooué",
                  "nameFr": "Moyen-Ogooué"
            },
            {
                  "name": "Ngounié",
                  "nameAr": "Ngounié",
                  "nameFr": "Ngounié"
            },
            {
                  "name": "Nyanga",
                  "nameAr": "Lune",
                  "nameFr": "Nyanga"
            },
            {
                  "name": "Ogooué-Ivindo",
                  "nameAr": "Ogooué-Ivindo",
                  "nameFr": "Ogooué-Ivindo"
            },
            {
                  "name": "Ogooué-Lolo",
                  "nameAr": "Ogooué-lolo",
                  "nameFr": "Ogooué-Lolo"
            },
            {
                  "name": "Ogooué-Maritime",
                  "nameAr": "Ogooué-Maritime",
                  "nameFr": "Ogooué-Maritime"
            },
            {
                  "name": "Woleu-Ntem",
                  "nameAr": "Woleu-Ntem",
                  "nameFr": "Woleu-Ntem"
            }
      ]
  },
  {
    "code": "GN",
    "name": "Guinea",
    "nameAr": "غينيا",
    "nameFr": "Guinea",
    "cities": [
            {
                  "name": "Beyla",
                  "nameAr": "Wedla",
                  "nameFr": "Beyla"
            },
            {
                  "name": "Boffa",
                  "nameAr": "Lampe",
                  "nameFr": "Boffa"
            },
            {
                  "name": "Boké",
                  "nameAr": "Boké",
                  "nameFr": "Boké"
            },
            {
                  "name": "Boké",
                  "nameAr": "Boké",
                  "nameFr": "Boké"
            },
            {
                  "name": "Conakry",
                  "nameAr": "Conakry",
                  "nameFr": "Conakry"
            },
            {
                  "name": "Coyah",
                  "nameAr": "Coyah",
                  "nameFr": "Coyah"
            },
            {
                  "name": "Dabola",
                  "nameAr": "Dabole",
                  "nameFr": "Dabola"
            },
            {
                  "name": "Dalaba",
                  "nameAr": "Délinquant",
                  "nameFr": "Dalaba"
            },
            {
                  "name": "Dinguiraye",
                  "nameAr": "Dinguiraye",
                  "nameFr": "Dinguiraye"
            },
            {
                  "name": "Dubréka",
                  "nameAr": "Surnommer",
                  "nameFr": "Dubréka"
            },
            {
                  "name": "Faranah",
                  "nameAr": "Faranah",
                  "nameFr": "Faranah"
            },
            {
                  "name": "Faranah",
                  "nameAr": "Faranah",
                  "nameFr": "Faranah"
            },
            {
                  "name": "Forécariah",
                  "nameAr": "Florécariah",
                  "nameFr": "Forécariah"
            },
            {
                  "name": "Fria",
                  "nameAr": "Gratuit",
                  "nameFr": "Fria"
            },
            {
                  "name": "Gaoual",
                  "nameAr": "Gaoual",
                  "nameFr": "Gaoual"
            },
            {
                  "name": "Guéckédou",
                  "nameAr": "Guidyou",
                  "nameFr": "Guéckédou"
            },
            {
                  "name": "Kankan",
                  "nameAr": "Non",
                  "nameFr": "Kankan"
            },
            {
                  "name": "Kankan",
                  "nameAr": "Non",
                  "nameFr": "Kankan"
            },
            {
                  "name": "Kérouané",
                  "nameAr": "Bronzé",
                  "nameFr": "Kérouané"
            },
            {
                  "name": "Kindia",
                  "nameAr": "Kindia",
                  "nameFr": "Kindia"
            },
            {
                  "name": "Kindia",
                  "nameAr": "Kindia",
                  "nameFr": "Kindia"
            },
            {
                  "name": "Kissidougou",
                  "nameAr": "Kissidougou",
                  "nameFr": "Kissidougou"
            },
            {
                  "name": "Koubia",
                  "nameAr": "Koubia",
                  "nameFr": "Koubia"
            },
            {
                  "name": "Koundara",
                  "nameAr": "Koundara",
                  "nameFr": "Koundara"
            },
            {
                  "name": "Kouroussa",
                  "nameAr": "Kouroussa",
                  "nameFr": "Kouroussa"
            },
            {
                  "name": "Labé",
                  "nameAr": "Labé",
                  "nameFr": "Labé"
            },
            {
                  "name": "Labé",
                  "nameAr": "Labé",
                  "nameFr": "Labé"
            },
            {
                  "name": "Lélouma",
                  "nameAr": "Lélouma",
                  "nameFr": "Lélouma"
            },
            {
                  "name": "Lola",
                  "nameAr": "Lola",
                  "nameFr": "Lola"
            },
            {
                  "name": "Macenta",
                  "nameAr": "Sa mélodie",
                  "nameFr": "Macenta"
            },
            {
                  "name": "Mali",
                  "nameAr": "Mali",
                  "nameFr": "Mali"
            },
            {
                  "name": "Mamou",
                  "nameAr": "Maman",
                  "nameFr": "Mamou"
            },
            {
                  "name": "Mamou",
                  "nameAr": "Maman",
                  "nameFr": "Mamou"
            },
            {
                  "name": "Mandiana",
                  "nameAr": "Mandiana",
                  "nameFr": "Mandiana"
            },
            {
                  "name": "Nzérékoré",
                  "nameAr": "Nzérékor",
                  "nameFr": "Nzérékoré"
            },
            {
                  "name": "Nzérékoré",
                  "nameAr": "Nzérékor",
                  "nameFr": "Nzérékoré"
            },
            {
                  "name": "Pita",
                  "nameAr": "Pita",
                  "nameFr": "Pita"
            },
            {
                  "name": "Siguiri",
                  "nameAr": "Siguiri",
                  "nameFr": "Siguiri"
            },
            {
                  "name": "Télimélé",
                  "nameAr": "Bord d'hiver",
                  "nameFr": "Télimélé"
            },
            {
                  "name": "Tougué",
                  "nameAr": "Tougué",
                  "nameFr": "Tougué"
            },
            {
                  "name": "Yomou",
                  "nameAr": "Yomou",
                  "nameFr": "Yomou"
            }
      ]
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "nameAr": "غينيا بيساو",
    "nameFr": "Guinea-Bissau",
    "cities": [
            {
                  "name": "Bafatá",
                  "nameAr": "Bafatá",
                  "nameFr": "Bafatá"
            },
            {
                  "name": "Biombo",
                  "nameAr": "Biombo",
                  "nameFr": "Biombo"
            },
            {
                  "name": "Bolama",
                  "nameAr": "Garoto",
                  "nameFr": "Bolama"
            },
            {
                  "name": "Cacheu",
                  "nameAr": "Cache",
                  "nameFr": "Cacheu"
            },
            {
                  "name": "Gabú",
                  "nameAr": "Gabú",
                  "nameFr": "Gabú"
            },
            {
                  "name": "Leste",
                  "nameAr": "Leste",
                  "nameFr": "Leste"
            },
            {
                  "name": "Norte",
                  "nameAr": "Norte",
                  "nameFr": "Norte"
            },
            {
                  "name": "Oio",
                  "nameAr": "Oio",
                  "nameFr": "Oio"
            },
            {
                  "name": "Quinara",
                  "nameAr": "Quinara",
                  "nameFr": "Quinara"
            },
            {
                  "name": "Sul",
                  "nameAr": "No",
                  "nameFr": "Sul"
            },
            {
                  "name": "Tombali",
                  "nameAr": "Tombali",
                  "nameFr": "Tombali"
            }
      ]
  },
  {
    "code": "KE",
    "name": "Kenya",
    "nameAr": "كينيا",
    "nameFr": "Kenya",
    "cities": [
            {
                  "name": "Baringo",
                  "nameAr": "Baringo",
                  "nameFr": "Baringo"
            },
            {
                  "name": "Bomet",
                  "nameAr": "Bomet",
                  "nameFr": "Bomet"
            },
            {
                  "name": "Bungoma",
                  "nameAr": "Bungoma",
                  "nameFr": "Bungoma"
            },
            {
                  "name": "Busia",
                  "nameAr": "Busia",
                  "nameFr": "Busia"
            },
            {
                  "name": "Elgeyo-Marakwet",
                  "nameAr": "Elgeyo-Marakwet",
                  "nameFr": "Elgeyo-Marakwet"
            },
            {
                  "name": "Embu",
                  "nameAr": "Embu",
                  "nameFr": "Embu"
            },
            {
                  "name": "Garissa",
                  "nameAr": "In the gar",
                  "nameFr": "Garissa"
            },
            {
                  "name": "Homa Bay",
                  "nameAr": "Homa Bay",
                  "nameFr": "Homa Bay"
            },
            {
                  "name": "Isiolo",
                  "nameAr": "Isiolo",
                  "nameFr": "Isiolo"
            },
            {
                  "name": "Kajiado",
                  "nameAr": "Kajiado",
                  "nameFr": "Kajiado"
            },
            {
                  "name": "Kakamega",
                  "nameAr": "Kakamega",
                  "nameFr": "Kakamega"
            },
            {
                  "name": "Kericho",
                  "nameAr": "Kericho",
                  "nameFr": "Kericho"
            },
            {
                  "name": "Kiambu",
                  "nameAr": "Kiambu",
                  "nameFr": "Kiambu"
            },
            {
                  "name": "Kilifi",
                  "nameAr": "Kilifi",
                  "nameFr": "Kilifi"
            },
            {
                  "name": "Kirinyaga",
                  "nameAr": "Kirinyaga",
                  "nameFr": "Kirinyaga"
            },
            {
                  "name": "Kisii",
                  "nameAr": "Kisii",
                  "nameFr": "Kisii"
            },
            {
                  "name": "Kisumu",
                  "nameAr": "Kisumu",
                  "nameFr": "Kisumu"
            },
            {
                  "name": "Kitui",
                  "nameAr": "Kitui",
                  "nameFr": "Kitui"
            },
            {
                  "name": "Kwale",
                  "nameAr": "Kwale",
                  "nameFr": "Kwale"
            },
            {
                  "name": "Laikipia",
                  "nameAr": "Laikipia",
                  "nameFr": "Laikipia"
            },
            {
                  "name": "Lamu",
                  "nameAr": "Lamu",
                  "nameFr": "Lamu"
            },
            {
                  "name": "Machakos",
                  "nameAr": "Machakos",
                  "nameFr": "Machakos"
            },
            {
                  "name": "Makueni",
                  "nameAr": "Makueni",
                  "nameFr": "Makueni"
            },
            {
                  "name": "Mandera",
                  "nameAr": "Mandera",
                  "nameFr": "Mandera"
            },
            {
                  "name": "Marsabit",
                  "nameAr": "Marsabit",
                  "nameFr": "Marsabit"
            },
            {
                  "name": "Meru",
                  "nameAr": "Meru",
                  "nameFr": "Meru"
            },
            {
                  "name": "Migori",
                  "nameAr": "Migori",
                  "nameFr": "Migori"
            },
            {
                  "name": "Mombasa",
                  "nameAr": "Mombasa",
                  "nameFr": "Mombasa"
            },
            {
                  "name": "Murang'a",
                  "nameAr": "cheap",
                  "nameFr": "Murang'a"
            },
            {
                  "name": "Nairobi City",
                  "nameAr": "Nairobi City",
                  "nameFr": "Nairobi City"
            },
            {
                  "name": "Nakuru",
                  "nameAr": "Nakuru",
                  "nameFr": "Nakuru"
            },
            {
                  "name": "Nandi",
                  "nameAr": "Nandi",
                  "nameFr": "Nandi"
            },
            {
                  "name": "Narok",
                  "nameAr": "Nasko",
                  "nameFr": "Narok"
            },
            {
                  "name": "Nyamira",
                  "nameAr": "Nyamira",
                  "nameFr": "Nyamira"
            },
            {
                  "name": "Nyandarua",
                  "nameAr": "Nyandarua",
                  "nameFr": "Nyandarua"
            },
            {
                  "name": "Nyeri",
                  "nameAr": "Nyeri",
                  "nameFr": "Nyeri"
            },
            {
                  "name": "Samburu",
                  "nameAr": "Samburu",
                  "nameFr": "Samburu"
            },
            {
                  "name": "Siaya",
                  "nameAr": "Siaya",
                  "nameFr": "Siaya"
            },
            {
                  "name": "Taita–Taveta",
                  "nameAr": "Taita -Taveta",
                  "nameFr": "Taita–Taveta"
            },
            {
                  "name": "Tana River",
                  "nameAr": "His river",
                  "nameFr": "Tana River"
            },
            {
                  "name": "Tharaka-Nithi",
                  "nameAr": "Tharaka-NITHI",
                  "nameFr": "Tharaka-Nithi"
            },
            {
                  "name": "Trans Nzoia",
                  "nameAr": "Trans Nzoia",
                  "nameFr": "Trans Nzoia"
            },
            {
                  "name": "Turkana",
                  "nameAr": "Turkana",
                  "nameFr": "Turkana"
            },
            {
                  "name": "Uasin Gishu",
                  "nameAr": "Uasin Gishu",
                  "nameFr": "Uasin Gishu"
            },
            {
                  "name": "Vihiga",
                  "nameAr": "Whip",
                  "nameFr": "Vihiga"
            },
            {
                  "name": "Wajir",
                  "nameAr": "Marin",
                  "nameFr": "Wajir"
            },
            {
                  "name": "West Pokot",
                  "nameAr": "West Pokot",
                  "nameFr": "West Pokot"
            }
      ]
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "nameAr": "ليسوتو",
    "nameFr": "Lesotho",
    "cities": [
            {
                  "name": "Berea",
                  "nameAr": "Berea",
                  "nameFr": "Berea"
            },
            {
                  "name": "Butha-Buthe",
                  "nameAr": "Butha-Buthe",
                  "nameFr": "Butha-Buthe"
            },
            {
                  "name": "Leribe",
                  "nameAr": "LERIBE",
                  "nameFr": "Leribe"
            },
            {
                  "name": "Mafeteng",
                  "nameAr": "Mafeteng",
                  "nameFr": "Mafeteng"
            },
            {
                  "name": "Maseru",
                  "nameAr": "Maseru",
                  "nameFr": "Maseru"
            },
            {
                  "name": "Mohale's Hoek",
                  "nameAr": "Mohale's corner",
                  "nameFr": "Mohale's Hoek"
            },
            {
                  "name": "Mokhotlong",
                  "nameAr": "Mokhotlong",
                  "nameFr": "Mokhotlong"
            },
            {
                  "name": "Qacha's Nek",
                  "nameAr": "Qacha's Nek",
                  "nameFr": "Qacha's Nek"
            },
            {
                  "name": "Quthing",
                  "nameAr": "Quthing",
                  "nameFr": "Quthing"
            },
            {
                  "name": "Thaba-Tseka",
                  "nameAr": "Butha-Buthe",
                  "nameFr": "Thaba-Tseka"
            }
      ]
  },
  {
    "code": "LR",
    "name": "Liberia",
    "nameAr": "ليبيريا",
    "nameFr": "Liberia",
    "cities": [
            {
                  "name": "Bomi",
                  "nameAr": "Bomi",
                  "nameFr": "Bomi"
            },
            {
                  "name": "Bong",
                  "nameAr": "Bong",
                  "nameFr": "Bong"
            },
            {
                  "name": "Gbarpolu",
                  "nameAr": "Ex",
                  "nameFr": "Gbarpolu"
            },
            {
                  "name": "Grand Bassa",
                  "nameAr": "Grand Bassa",
                  "nameFr": "Grand Bassa"
            },
            {
                  "name": "Grand Cape Mount",
                  "nameAr": "Grand Cape Mount",
                  "nameFr": "Grand Cape Mount"
            },
            {
                  "name": "Grand Gedeh",
                  "nameAr": "Grand Gedeh",
                  "nameFr": "Grand Gedeh"
            },
            {
                  "name": "Grand Kru",
                  "nameAr": "Grand crew",
                  "nameFr": "Grand Kru"
            },
            {
                  "name": "Lofa",
                  "nameAr": "Applaud",
                  "nameFr": "Lofa"
            },
            {
                  "name": "Margibi",
                  "nameAr": "Margibi",
                  "nameFr": "Margibi"
            },
            {
                  "name": "Maryland",
                  "nameAr": "Maryland",
                  "nameFr": "Maryland"
            },
            {
                  "name": "Montserrado",
                  "nameAr": "Montserrado",
                  "nameFr": "Montserrado"
            },
            {
                  "name": "Nimba",
                  "nameAr": "If",
                  "nameFr": "Nimba"
            },
            {
                  "name": "River Cess",
                  "nameAr": "River Cess",
                  "nameFr": "River Cess"
            },
            {
                  "name": "River Gee",
                  "nameAr": "River Gee",
                  "nameFr": "River Gee"
            },
            {
                  "name": "Sinoe",
                  "nameAr": "SINOIE",
                  "nameFr": "Sinoe"
            }
      ]
  },
  {
    "code": "LY",
    "name": "Libya",
    "nameAr": "ليبيا",
    "nameFr": "Libya",
    "cities": [
            {
                  "name": "Al Wahat",
                  "nameAr": "الواه",
                  "nameFr": "Al Wahat"
            },
            {
                  "name": "Benghazi",
                  "nameAr": "بنغازي",
                  "nameFr": "Benghazi"
            },
            {
                  "name": "Derna",
                  "nameAr": "Derna",
                  "nameFr": "Derna"
            },
            {
                  "name": "Ghat",
                  "nameAr": "غات",
                  "nameFr": "Ghat"
            },
            {
                  "name": "Jabal al Akhdar",
                  "nameAr": "Jabal al Akhdar",
                  "nameFr": "Jabal al Akhdar"
            },
            {
                  "name": "Jabal al Gharbi",
                  "nameAr": "Jabal al Gharbi",
                  "nameFr": "Jabal al Gharbi"
            },
            {
                  "name": "Jafara",
                  "nameAr": "Jafara",
                  "nameFr": "Jafara"
            },
            {
                  "name": "Jufra",
                  "nameAr": "jufra",
                  "nameFr": "Jufra"
            },
            {
                  "name": "Kufra",
                  "nameAr": "صُندُوق",
                  "nameFr": "Kufra"
            },
            {
                  "name": "Marj",
                  "nameAr": "مارج",
                  "nameFr": "Marj"
            },
            {
                  "name": "Misrata",
                  "nameAr": "أسراتا",
                  "nameFr": "Misrata"
            },
            {
                  "name": "Murqub",
                  "nameAr": "murqub",
                  "nameFr": "Murqub"
            },
            {
                  "name": "Murzuq",
                  "nameAr": "مورزوك",
                  "nameFr": "Murzuq"
            },
            {
                  "name": "Nalut",
                  "nameAr": "نالوت",
                  "nameFr": "Nalut"
            },
            {
                  "name": "Nuqat al Khams",
                  "nameAr": "Nuqat al Khams",
                  "nameFr": "Nuqat al Khams"
            },
            {
                  "name": "Sabha",
                  "nameAr": "سبها",
                  "nameFr": "Sabha"
            },
            {
                  "name": "Sirte",
                  "nameAr": "سيرتي",
                  "nameFr": "Sirte"
            },
            {
                  "name": "Tripoli",
                  "nameAr": "طرابلس",
                  "nameFr": "Tripoli"
            },
            {
                  "name": "Wadi al Hayaa",
                  "nameAr": "Wadi al Hayaa",
                  "nameFr": "Wadi al Hayaa"
            },
            {
                  "name": "Wadi al Shatii",
                  "nameAr": "طريق الشادي",
                  "nameFr": "Wadi al Shatii"
            },
            {
                  "name": "Zawiya",
                  "nameAr": "زاويا",
                  "nameFr": "Zawiya"
            }
      ]
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "nameAr": "مدغشقر",
    "nameFr": "Madagascar",
    "cities": [
            {
                  "name": "Antananarivo",
                  "nameAr": "Antananarivo",
                  "nameFr": "Antananarivo"
            },
            {
                  "name": "Antsiranana",
                  "nameAr": "Antsiranana",
                  "nameFr": "Antsiranana"
            },
            {
                  "name": "Fianarantsoa",
                  "nameAr": "Fianarantsoa",
                  "nameFr": "Fianarantsoa"
            },
            {
                  "name": "Mahajanga",
                  "nameAr": "Mahajanga",
                  "nameFr": "Mahajanga"
            },
            {
                  "name": "Toamasina",
                  "nameAr": "Toamasina",
                  "nameFr": "Toamasina"
            },
            {
                  "name": "Toliara",
                  "nameAr": "Toliara",
                  "nameFr": "Toliara"
            }
      ]
  },
  {
    "code": "MW",
    "name": "Malawi",
    "nameAr": "مالاوي",
    "nameFr": "Malawi",
    "cities": [
            {
                  "name": "Balaka",
                  "nameAr": "Balaka",
                  "nameFr": "Balaka"
            },
            {
                  "name": "Blantyre",
                  "nameAr": "Blantyre",
                  "nameFr": "Blantyre"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Chikwawa",
                  "nameAr": "Chikwawa",
                  "nameFr": "Chikwawa"
            },
            {
                  "name": "Chiradzulu",
                  "nameAr": "Shael",
                  "nameFr": "Chiradzulu"
            },
            {
                  "name": "Chitipa",
                  "nameAr": "Carpea",
                  "nameFr": "Chitipa"
            },
            {
                  "name": "Dedza",
                  "nameAr": "DEEE",
                  "nameFr": "Dedza"
            },
            {
                  "name": "Dowa",
                  "nameAr": "Dowo",
                  "nameFr": "Dowa"
            },
            {
                  "name": "Karonga",
                  "nameAr": "Accessories",
                  "nameFr": "Karonga"
            },
            {
                  "name": "Kasungu",
                  "nameAr": "Sowning",
                  "nameFr": "Kasungu"
            },
            {
                  "name": "Likoma",
                  "nameAr": "Love",
                  "nameFr": "Likoma"
            },
            {
                  "name": "Lilongwe",
                  "nameAr": "Lilongwe",
                  "nameFr": "Lilongwe"
            },
            {
                  "name": "Machinga",
                  "nameAr": "Machinga",
                  "nameFr": "Machinga"
            },
            {
                  "name": "Mangochi",
                  "nameAr": "Mangochi",
                  "nameFr": "Mangochi"
            },
            {
                  "name": "Mchinji",
                  "nameAr": "Hybpha",
                  "nameFr": "Mchinji"
            },
            {
                  "name": "Mulanje",
                  "nameAr": "Poporary",
                  "nameFr": "Mulanje"
            },
            {
                  "name": "Mwanza",
                  "nameAr": "Mwanza",
                  "nameFr": "Mwanza"
            },
            {
                  "name": "Mzimba",
                  "nameAr": "Immoral",
                  "nameFr": "Mzimba"
            },
            {
                  "name": "Neno",
                  "nameAr": "The word",
                  "nameFr": "Neno"
            },
            {
                  "name": "Nkhata Bay",
                  "nameAr": "Correas",
                  "nameFr": "Nkhata Bay"
            },
            {
                  "name": "Nkhotakota",
                  "nameAr": "Blast",
                  "nameFr": "Nkhotakota"
            },
            {
                  "name": "Northern",
                  "nameAr": "Northern",
                  "nameFr": "Northern"
            },
            {
                  "name": "Nsanje",
                  "nameAr": "Jealousy",
                  "nameFr": "Nsanje"
            },
            {
                  "name": "Ntcheu",
                  "nameAr": "Ntcheu",
                  "nameFr": "Ntcheu"
            },
            {
                  "name": "Ntchisi",
                  "nameAr": "Nice",
                  "nameFr": "Ntchisi"
            },
            {
                  "name": "Phalombe",
                  "nameAr": "Olf",
                  "nameFr": "Phalombe"
            },
            {
                  "name": "Rumphi",
                  "nameAr": "Rumphi",
                  "nameFr": "Rumphi"
            },
            {
                  "name": "Salima",
                  "nameAr": "Salima",
                  "nameFr": "Salima"
            },
            {
                  "name": "Southern",
                  "nameAr": "Southern",
                  "nameFr": "Southern"
            },
            {
                  "name": "Thyolo",
                  "nameAr": "The thin",
                  "nameFr": "Thyolo"
            },
            {
                  "name": "Zomba",
                  "nameAr": "Abortion",
                  "nameFr": "Zomba"
            }
      ]
  },
  {
    "code": "ML",
    "name": "Mali",
    "nameAr": "مالي",
    "nameFr": "Mali",
    "cities": [
            {
                  "name": "Bamako",
                  "nameAr": "Bamako",
                  "nameFr": "Bamako"
            },
            {
                  "name": "Gao",
                  "nameAr": "Gao",
                  "nameFr": "Gao"
            },
            {
                  "name": "Kayes",
                  "nameAr": "Kayes",
                  "nameFr": "Kayes"
            },
            {
                  "name": "Kidal",
                  "nameAr": "Gauche -",
                  "nameFr": "Kidal"
            },
            {
                  "name": "Koulikoro",
                  "nameAr": "Koulikoro",
                  "nameFr": "Koulikoro"
            },
            {
                  "name": "Ménaka",
                  "nameAr": "Ménaka",
                  "nameFr": "Ménaka"
            },
            {
                  "name": "Mopti",
                  "nameAr": "Mopti",
                  "nameFr": "Mopti"
            },
            {
                  "name": "Ségou",
                  "nameAr": "Ségou",
                  "nameFr": "Ségou"
            },
            {
                  "name": "Sikasso",
                  "nameAr": "Sikasso",
                  "nameFr": "Sikasso"
            },
            {
                  "name": "Taoudénit",
                  "nameAr": "Taoudénit",
                  "nameFr": "Taoudénit"
            },
            {
                  "name": "Tombouctou",
                  "nameAr": "Tombouctou",
                  "nameFr": "Tombouctou"
            }
      ]
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "nameAr": "موريتانيا",
    "nameFr": "Mauritania",
    "cities": [
            {
                  "name": "Adrar",
                  "nameAr": "آخر",
                  "nameFr": "Adrar"
            },
            {
                  "name": "Assaba",
                  "nameAr": "الدعاء",
                  "nameFr": "Assaba"
            },
            {
                  "name": "Brakna",
                  "nameAr": "راحة",
                  "nameFr": "Brakna"
            },
            {
                  "name": "Dakhlet Nouadhibou",
                  "nameAr": "Dakhlet Nouadhibou",
                  "nameFr": "Dakhlet Nouadhibou"
            },
            {
                  "name": "Gorgol",
                  "nameAr": "جورجول",
                  "nameFr": "Gorgol"
            },
            {
                  "name": "Guidimaka",
                  "nameAr": "Guidimuka",
                  "nameFr": "Guidimaka"
            },
            {
                  "name": "Hodh Ech Chargui",
                  "nameAr": "هوده صدى تشارغي",
                  "nameFr": "Hodh Ech Chargui"
            },
            {
                  "name": "Hodh El Gharbi",
                  "nameAr": "Hodh El Gharbi",
                  "nameFr": "Hodh El Gharbi"
            },
            {
                  "name": "Inchiri",
                  "nameAr": "بوصات",
                  "nameFr": "Inchiri"
            },
            {
                  "name": "Nouakchott-Nord",
                  "nameAr": "Nouakchott-Nord",
                  "nameFr": "Nouakchott-Nord"
            },
            {
                  "name": "Nouakchott-Ouest",
                  "nameAr": "Nouakchott-OUEST",
                  "nameFr": "Nouakchott-Ouest"
            },
            {
                  "name": "Nouakchott-Sud",
                  "nameAr": "Nouakchott-Sud",
                  "nameFr": "Nouakchott-Sud"
            },
            {
                  "name": "Tagant",
                  "nameAr": "من الخلف",
                  "nameFr": "Tagant"
            },
            {
                  "name": "Tiris Zemmour",
                  "nameAr": "Tiris Zemmour",
                  "nameFr": "Tiris Zemmour"
            },
            {
                  "name": "Trarza",
                  "nameAr": "السفر",
                  "nameFr": "Trarza"
            }
      ]
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "nameAr": "موريشيوس",
    "nameFr": "Mauritius",
    "cities": [
            {
                  "name": "Agalega Islands",
                  "nameAr": "Agly Islands",
                  "nameFr": "Agalega Islands"
            },
            {
                  "name": "Black River",
                  "nameAr": "Black River",
                  "nameFr": "Black River"
            },
            {
                  "name": "Flacq",
                  "nameAr": "Flacq",
                  "nameFr": "Flacq"
            },
            {
                  "name": "Grand Port",
                  "nameAr": "Grand Port",
                  "nameFr": "Grand Port"
            },
            {
                  "name": "Moka",
                  "nameAr": "Moka",
                  "nameFr": "Moka"
            },
            {
                  "name": "Pamplemousses",
                  "nameAr": "Pamplemousses",
                  "nameFr": "Pamplemousses"
            },
            {
                  "name": "Plaines Wilhems",
                  "nameAr": "Plaines Wilhems",
                  "nameFr": "Plaines Wilhems"
            },
            {
                  "name": "Port Louis",
                  "nameAr": "Port Louis",
                  "nameFr": "Port Louis"
            },
            {
                  "name": "Rivière du Rempart",
                  "nameAr": "Rampart river",
                  "nameFr": "Rivière du Rempart"
            },
            {
                  "name": "Rodrigues Island",
                  "nameAr": "Rodrigues Island",
                  "nameFr": "Rodrigues Island"
            },
            {
                  "name": "Saint Brandon Islands",
                  "nameAr": "Saint Brandon Islands",
                  "nameFr": "Saint Brandon Islands"
            },
            {
                  "name": "Savanne",
                  "nameAr": "Savanne",
                  "nameFr": "Savanne"
            }
      ]
  },
  {
    "code": "YT",
    "name": "Mayotte",
    "nameAr": "مايوت",
    "nameFr": "Mayotte",
    "cities": [
            {
                  "name": "Acoua",
                  "nameAr": "Acoua",
                  "nameFr": "Acoua"
            },
            {
                  "name": "Bandraboua",
                  "nameAr": "Bandraboua",
                  "nameFr": "Bandraboua"
            },
            {
                  "name": "Bandrélé",
                  "nameAr": "Bandrelé",
                  "nameFr": "Bandrélé"
            },
            {
                  "name": "Boueni",
                  "nameAr": "Bouen",
                  "nameFr": "Boueni"
            },
            {
                  "name": "Chiconi",
                  "nameAr": "Chiconi",
                  "nameFr": "Chiconi"
            },
            {
                  "name": "Chirongui",
                  "nameAr": "Chirongui",
                  "nameFr": "Chirongui"
            },
            {
                  "name": "Dembeni",
                  "nameAr": "Débat",
                  "nameFr": "Dembeni"
            },
            {
                  "name": "Dzaoudzi",
                  "nameAr": "Leur",
                  "nameFr": "Dzaoudzi"
            },
            {
                  "name": "Kani Keli",
                  "nameAr": "Ce seul",
                  "nameFr": "Kani Keli"
            },
            {
                  "name": "Koungou",
                  "nameAr": "Maintenant",
                  "nameFr": "Koungou"
            },
            {
                  "name": "M'Tsangamouji",
                  "nameAr": "Entrée",
                  "nameFr": "M'Tsangamouji"
            },
            {
                  "name": "Mamoudzou",
                  "nameAr": "Mamoudzou",
                  "nameFr": "Mamoudzou"
            },
            {
                  "name": "Mtsamboro",
                  "nameAr": "Mtsamboro",
                  "nameFr": "Mtsamboro"
            },
            {
                  "name": "Ouangani",
                  "nameAr": "Ambitieux",
                  "nameFr": "Ouangani"
            },
            {
                  "name": "Pamandzi",
                  "nameAr": "En ville",
                  "nameFr": "Pamandzi"
            },
            {
                  "name": "Sada",
                  "nameAr": "Maintenant",
                  "nameFr": "Sada"
            },
            {
                  "name": "Tsingoni",
                  "nameAr": "Tsingoni",
                  "nameFr": "Tsingoni"
            }
      ]
  },
  {
    "code": "MA",
    "name": "Morocco",
    "nameAr": "المغرب",
    "nameFr": "Morocco",
    "cities": [
            {
                  "name": "Agadir-Ida-Ou-Tanane",
                  "nameAr": "Agadir-Ida-or-Tanane",
                  "nameFr": "Agadir-Ida-Ou-Tanane"
            },
            {
                  "name": "Al Haouz",
                  "nameAr": "Al Haouz",
                  "nameFr": "Al Haouz"
            },
            {
                  "name": "Al Hoceïma",
                  "nameAr": "Al Hoceïma",
                  "nameFr": "Al Hoceïma"
            },
            {
                  "name": "Aousserd (EH)",
                  "nameAr": "Aousserd (إيه)",
                  "nameFr": "Aousserd (EH)"
            },
            {
                  "name": "Assa-Zag (EH-partial)",
                  "nameAr": "Assa-Zag (EH-Partial)",
                  "nameFr": "Assa-Zag (EH-partial)"
            },
            {
                  "name": "Azilal",
                  "nameAr": "Azilal",
                  "nameFr": "Azilal"
            },
            {
                  "name": "Béni Mellal",
                  "nameAr": "مبارك ميلال",
                  "nameFr": "Béni Mellal"
            },
            {
                  "name": "Béni Mellal-Khénifra",
                  "nameAr": "Béni Mellal-Khénifra",
                  "nameFr": "Béni Mellal-Khénifra"
            },
            {
                  "name": "Benslimane",
                  "nameAr": "بنسلمان",
                  "nameFr": "Benslimane"
            },
            {
                  "name": "Berkane",
                  "nameAr": "بيركان",
                  "nameFr": "Berkane"
            },
            {
                  "name": "Berrechid",
                  "nameAr": "بيريشيد",
                  "nameFr": "Berrechid"
            },
            {
                  "name": "Boujdour (EH)",
                  "nameAr": "بوجدور (إيه)",
                  "nameFr": "Boujdour (EH)"
            },
            {
                  "name": "Boulemane",
                  "nameAr": "غمغم",
                  "nameFr": "Boulemane"
            },
            {
                  "name": "Casablanca",
                  "nameAr": "الدار البيضاء",
                  "nameFr": "Casablanca"
            },
            {
                  "name": "Casablanca-Settat",
                  "nameAr": "Casablanca-Settat",
                  "nameFr": "Casablanca-Settat"
            },
            {
                  "name": "Chefchaouen",
                  "nameAr": "شيفخوين",
                  "nameFr": "Chefchaouen"
            },
            {
                  "name": "Chichaoua",
                  "nameAr": "Chichaoua",
                  "nameFr": "Chichaoua"
            },
            {
                  "name": "Chtouka-Ait Baha",
                  "nameAr": "Chtouka-Aait Baha",
                  "nameFr": "Chtouka-Ait Baha"
            },
            {
                  "name": "Dakhla-Oued Ed-Dahab (EH)",
                  "nameAr": "Dakhla-Oued Ed-Dahab (EH)",
                  "nameFr": "Dakhla-Oued Ed-Dahab (EH)"
            },
            {
                  "name": "Drâa-Tafilalet",
                  "nameAr": "Drâa-tafilalet",
                  "nameFr": "Drâa-Tafilalet"
            },
            {
                  "name": "Driouch",
                  "nameAr": "دريوش",
                  "nameFr": "Driouch"
            },
            {
                  "name": "El Hajeb",
                  "nameAr": "El Hajeb",
                  "nameFr": "El Hajeb"
            },
            {
                  "name": "El Jadida",
                  "nameAr": "جاديدا",
                  "nameFr": "El Jadida"
            },
            {
                  "name": "El Kelâa des Sraghna",
                  "nameAr": "El Kelâa des Sraghna",
                  "nameFr": "El Kelâa des Sraghna"
            },
            {
                  "name": "Errachidia",
                  "nameAr": "errachidia",
                  "nameFr": "Errachidia"
            },
            {
                  "name": "Es-Semara (EH-partial)",
                  "nameAr": "es-seAlm (eh-party)",
                  "nameFr": "Es-Semara (EH-partial)"
            },
            {
                  "name": "Essaouira",
                  "nameAr": "Essaouira",
                  "nameFr": "Essaouira"
            },
            {
                  "name": "Fahs-Anjra",
                  "nameAr": "فاهس أوجرا",
                  "nameFr": "Fahs-Anjra"
            },
            {
                  "name": "Fès",
                  "nameAr": "فز",
                  "nameFr": "Fès"
            },
            {
                  "name": "Fès-Meknès",
                  "nameAr": "Fez-Meknès",
                  "nameFr": "Fès-Meknès"
            },
            {
                  "name": "Figuig",
                  "nameAr": "فيجويج",
                  "nameFr": "Figuig"
            },
            {
                  "name": "Fquih Ben Salah",
                  "nameAr": "Fquih Ben مخطئ",
                  "nameFr": "Fquih Ben Salah"
            },
            {
                  "name": "Guelmim",
                  "nameAr": "جيلميم",
                  "nameFr": "Guelmim"
            },
            {
                  "name": "Guelmim-Oued Noun (EH-partial)",
                  "nameAr": "اسم (EH-Partial) Guelmim",
                  "nameFr": "Guelmim-Oued Noun (EH-partial)"
            },
            {
                  "name": "Guercif",
                  "nameAr": "Guercif",
                  "nameFr": "Guercif"
            },
            {
                  "name": "Ifrane",
                  "nameAr": "الإيفرين",
                  "nameFr": "Ifrane"
            },
            {
                  "name": "Inezgane-Ait Melloul",
                  "nameAr": "Inezgane-Ait Melloul",
                  "nameFr": "Inezgane-Ait Melloul"
            },
            {
                  "name": "Jerada",
                  "nameAr": "جيرادا",
                  "nameFr": "Jerada"
            },
            {
                  "name": "Kénitra",
                  "nameAr": "كينيترا",
                  "nameFr": "Kénitra"
            },
            {
                  "name": "Khémisset",
                  "nameAr": "خميس",
                  "nameFr": "Khémisset"
            },
            {
                  "name": "Khénifra",
                  "nameAr": "Khénifra",
                  "nameFr": "Khénifra"
            },
            {
                  "name": "Khouribga",
                  "nameAr": "Khouribga",
                  "nameFr": "Khouribga"
            },
            {
                  "name": "L'Oriental",
                  "nameAr": "L'IRITAL",
                  "nameFr": "L'Oriental"
            },
            {
                  "name": "Laâyoune (EH)",
                  "nameAr": "laâyoun (إيه)",
                  "nameFr": "Laâyoune (EH)"
            },
            {
                  "name": "Laâyoune-Sakia El Hamra (EH-partial)",
                  "nameAr": "Laâyoune-Sakia El Hamra (EH-Partial)",
                  "nameFr": "Laâyoune-Sakia El Hamra (EH-partial)"
            },
            {
                  "name": "Larache",
                  "nameAr": "لاراش",
                  "nameFr": "Larache"
            },
            {
                  "name": "M’diq-Fnideq",
                  "nameAr": "m'qqq-fnideq",
                  "nameFr": "M’diq-Fnideq"
            },
            {
                  "name": "Marrakech",
                  "nameAr": "مراكش",
                  "nameFr": "Marrakech"
            },
            {
                  "name": "Marrakesh-Safi",
                  "nameAr": "مراكش سافي",
                  "nameFr": "Marrakesh-Safi"
            },
            {
                  "name": "Médiouna",
                  "nameAr": "ميديونا",
                  "nameFr": "Médiouna"
            },
            {
                  "name": "Meknès",
                  "nameAr": "meknès",
                  "nameFr": "Meknès"
            },
            {
                  "name": "Midelt",
                  "nameAr": "متوسط",
                  "nameFr": "Midelt"
            },
            {
                  "name": "Mohammadia",
                  "nameAr": "محمدية",
                  "nameFr": "Mohammadia"
            },
            {
                  "name": "Moulay Yacoub",
                  "nameAr": "مولاي ياكوب",
                  "nameFr": "Moulay Yacoub"
            },
            {
                  "name": "Nador",
                  "nameAr": "نادور",
                  "nameFr": "Nador"
            },
            {
                  "name": "Nouaceur",
                  "nameAr": "Nouaceur",
                  "nameFr": "Nouaceur"
            },
            {
                  "name": "Ouarzazate",
                  "nameAr": "ouarzazate",
                  "nameFr": "Ouarzazate"
            },
            {
                  "name": "Oued Ed-Dahab (EH)",
                  "nameAr": "التعليم التعليمي (إيه)",
                  "nameFr": "Oued Ed-Dahab (EH)"
            },
            {
                  "name": "Ouezzane",
                  "nameAr": "Ouezzane",
                  "nameFr": "Ouezzane"
            },
            {
                  "name": "Oujda-Angad",
                  "nameAr": "oujda-angad",
                  "nameFr": "Oujda-Angad"
            },
            {
                  "name": "Rabat",
                  "nameAr": "الرباط",
                  "nameFr": "Rabat"
            },
            {
                  "name": "Rabat-Salé-Kénitra",
                  "nameAr": "الرباط-كوكيترا",
                  "nameFr": "Rabat-Salé-Kénitra"
            },
            {
                  "name": "Rehamna",
                  "nameAr": "Rehyna",
                  "nameFr": "Rehamna"
            },
            {
                  "name": "Safi",
                  "nameAr": "صوف",
                  "nameFr": "Safi"
            },
            {
                  "name": "Salé",
                  "nameAr": "متسخ",
                  "nameFr": "Salé"
            },
            {
                  "name": "Sefrou",
                  "nameAr": "سفرو",
                  "nameFr": "Sefrou"
            },
            {
                  "name": "Settat",
                  "nameAr": "تسوية",
                  "nameFr": "Settat"
            },
            {
                  "name": "Sidi Bennour",
                  "nameAr": "Sidi Bennour",
                  "nameFr": "Sidi Bennour"
            },
            {
                  "name": "Sidi Ifni",
                  "nameAr": "سيدي ifni",
                  "nameFr": "Sidi Ifni"
            },
            {
                  "name": "Sidi Kacem",
                  "nameAr": "سيدي",
                  "nameFr": "Sidi Kacem"
            },
            {
                  "name": "Sidi Slimane",
                  "nameAr": "سيدي سليمان",
                  "nameFr": "Sidi Slimane"
            },
            {
                  "name": "Skhirate-Témara",
                  "nameAr": "Skhirate-Temara",
                  "nameFr": "Skhirate-Témara"
            },
            {
                  "name": "Souss-Massa",
                  "nameAr": "Souss-Massa",
                  "nameFr": "Souss-Massa"
            },
            {
                  "name": "Tan-Tan (EH-partial)",
                  "nameAr": "و (EH-Partial)",
                  "nameFr": "Tan-Tan (EH-partial)"
            },
            {
                  "name": "Tanger-Assilah",
                  "nameAr": "Tanger-Assilah",
                  "nameFr": "Tanger-Assilah"
            },
            {
                  "name": "Tanger-Tétouan-Al Hoceïma",
                  "nameAr": "طنجة توتوان-هوكيما",
                  "nameFr": "Tanger-Tétouan-Al Hoceïma"
            },
            {
                  "name": "Taounate",
                  "nameAr": "taioounate",
                  "nameFr": "Taounate"
            },
            {
                  "name": "Taourirt",
                  "nameAr": "taourirt",
                  "nameFr": "Taourirt"
            },
            {
                  "name": "Tarfaya (EH-partial)",
                  "nameAr": "طرفايا (EH-Partial)",
                  "nameFr": "Tarfaya (EH-partial)"
            },
            {
                  "name": "Taroudannt",
                  "nameAr": "Taroudannt",
                  "nameFr": "Taroudannt"
            },
            {
                  "name": "Tata",
                  "nameAr": "تاتا",
                  "nameFr": "Tata"
            },
            {
                  "name": "Taza",
                  "nameAr": "كوب",
                  "nameFr": "Taza"
            },
            {
                  "name": "Tétouan",
                  "nameAr": "التيتوان",
                  "nameFr": "Tétouan"
            },
            {
                  "name": "Tinghir",
                  "nameAr": "تينغهير",
                  "nameFr": "Tinghir"
            },
            {
                  "name": "Tiznit",
                  "nameAr": "tiznit",
                  "nameFr": "Tiznit"
            },
            {
                  "name": "Youssoufia",
                  "nameAr": "youssoufia",
                  "nameFr": "Youssoufia"
            },
            {
                  "name": "Zagora",
                  "nameAr": "زاجورا",
                  "nameFr": "Zagora"
            }
      ]
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "nameAr": "موزمبيق",
    "nameFr": "Mozambique",
    "cities": [
            {
                  "name": "Cabo Delgado",
                  "nameAr": "Cabo Delgado",
                  "nameFr": "Cabo Delgado"
            },
            {
                  "name": "Gaza",
                  "nameAr": "Gaza",
                  "nameFr": "Gaza"
            },
            {
                  "name": "Inhambane",
                  "nameAr": "Inhambane",
                  "nameFr": "Inhambane"
            },
            {
                  "name": "Manica",
                  "nameAr": "Manga",
                  "nameFr": "Manica"
            },
            {
                  "name": "Maputo",
                  "nameAr": "Maputo",
                  "nameFr": "Maputo"
            },
            {
                  "name": "Maputo",
                  "nameAr": "Maputo",
                  "nameFr": "Maputo"
            },
            {
                  "name": "Nampula",
                  "nameAr": "Nampula",
                  "nameFr": "Nampula"
            },
            {
                  "name": "Niassa",
                  "nameAr": "Niassa",
                  "nameFr": "Niassa"
            },
            {
                  "name": "Sofala",
                  "nameAr": "Sofala",
                  "nameFr": "Sofala"
            },
            {
                  "name": "Tete",
                  "nameAr": "Tete",
                  "nameFr": "Tete"
            },
            {
                  "name": "Zambezia",
                  "nameAr": "Zambeze",
                  "nameFr": "Zambezia"
            }
      ]
  },
  {
    "code": "NA",
    "name": "Namibia",
    "nameAr": "ناميبيا",
    "nameFr": "Namibia",
    "cities": [
            {
                  "name": "Erongo",
                  "nameAr": "Erongo",
                  "nameFr": "Erongo"
            },
            {
                  "name": "Hardap",
                  "nameAr": "Hardap",
                  "nameFr": "Hardap"
            },
            {
                  "name": "Karas",
                  "nameAr": "Karas",
                  "nameFr": "Karas"
            },
            {
                  "name": "Kavango East",
                  "nameAr": "Kavango East",
                  "nameFr": "Kavango East"
            },
            {
                  "name": "Kavango West",
                  "nameAr": "The kada West",
                  "nameFr": "Kavango West"
            },
            {
                  "name": "Khomas",
                  "nameAr": "Khomas",
                  "nameFr": "Khomas"
            },
            {
                  "name": "Kunene",
                  "nameAr": "Right",
                  "nameFr": "Kunene"
            },
            {
                  "name": "Ohangwena",
                  "nameAr": "Ohangwena",
                  "nameFr": "Ohangwena"
            },
            {
                  "name": "Omaheke",
                  "nameAr": "Omaheke",
                  "nameFr": "Omaheke"
            },
            {
                  "name": "Omusati",
                  "nameAr": "Omusati",
                  "nameFr": "Omusati"
            },
            {
                  "name": "Oshana",
                  "nameAr": "Oshana",
                  "nameFr": "Oshana"
            },
            {
                  "name": "Oshikoto",
                  "nameAr": "Oshikoto",
                  "nameFr": "Oshikoto"
            },
            {
                  "name": "Otjozondjupa",
                  "nameAr": "Otjozondjupa",
                  "nameFr": "Otjozondjupa"
            },
            {
                  "name": "Zambezi",
                  "nameAr": "Zambezi",
                  "nameFr": "Zambezi"
            }
      ]
  },
  {
    "code": "NE",
    "name": "Niger",
    "nameAr": "النيجر",
    "nameFr": "Niger",
    "cities": [
            {
                  "name": "Agadez",
                  "nameAr": "Agadez",
                  "nameFr": "Agadez"
            },
            {
                  "name": "Diffa",
                  "nameAr": "Distraction",
                  "nameFr": "Diffa"
            },
            {
                  "name": "Dosso",
                  "nameAr": "Dossier",
                  "nameFr": "Dosso"
            },
            {
                  "name": "Maradi",
                  "nameAr": "Marigi",
                  "nameFr": "Maradi"
            },
            {
                  "name": "Tahoua",
                  "nameAr": "Unité",
                  "nameFr": "Tahoua"
            },
            {
                  "name": "Tillabéri",
                  "nameAr": "Tilla",
                  "nameFr": "Tillabéri"
            },
            {
                  "name": "Zinder",
                  "nameAr": "Zinder",
                  "nameFr": "Zinder"
            }
      ]
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "nameAr": "نيجيريا",
    "nameFr": "Nigeria",
    "cities": [
            {
                  "name": "Abia",
                  "nameAr": "Abia",
                  "nameFr": "Abia"
            },
            {
                  "name": "Abuja Federal Capital Territory",
                  "nameAr": "Abuja Federal Capital Territory",
                  "nameFr": "Abuja Federal Capital Territory"
            },
            {
                  "name": "Adamawa",
                  "nameAr": "Adamawa",
                  "nameFr": "Adamawa"
            },
            {
                  "name": "Akwa Ibom",
                  "nameAr": "Immoral",
                  "nameFr": "Akwa Ibom"
            },
            {
                  "name": "Anambra",
                  "nameAr": "Anambra",
                  "nameFr": "Anambra"
            },
            {
                  "name": "Bauchi",
                  "nameAr": "Bauchi",
                  "nameFr": "Bauchi"
            },
            {
                  "name": "Bayelsa",
                  "nameAr": "Bayelsa",
                  "nameFr": "Bayelsa"
            },
            {
                  "name": "Benue",
                  "nameAr": "Benue",
                  "nameFr": "Benue"
            },
            {
                  "name": "Borno",
                  "nameAr": "Borno",
                  "nameFr": "Borno"
            },
            {
                  "name": "Cross River",
                  "nameAr": "Cross River",
                  "nameFr": "Cross River"
            },
            {
                  "name": "Delta",
                  "nameAr": "Delta",
                  "nameFr": "Delta"
            },
            {
                  "name": "Ebonyi",
                  "nameAr": "Ebonyi",
                  "nameFr": "Ebonyi"
            },
            {
                  "name": "Edo",
                  "nameAr": "Or",
                  "nameFr": "Edo"
            },
            {
                  "name": "Ekiti",
                  "nameAr": "Ekiti",
                  "nameFr": "Ekiti"
            },
            {
                  "name": "Enugu",
                  "nameAr": "Enugu",
                  "nameFr": "Enugu"
            },
            {
                  "name": "Gombe",
                  "nameAr": "Gombe",
                  "nameFr": "Gombe"
            },
            {
                  "name": "Imo",
                  "nameAr": "Imo",
                  "nameFr": "Imo"
            },
            {
                  "name": "Jigawa",
                  "nameAr": "Jigawa",
                  "nameFr": "Jigawa"
            },
            {
                  "name": "Kaduna",
                  "nameAr": "Kaduna",
                  "nameFr": "Kaduna"
            },
            {
                  "name": "Kano",
                  "nameAr": "Kano",
                  "nameFr": "Kano"
            },
            {
                  "name": "Katsina",
                  "nameAr": "Katsina",
                  "nameFr": "Katsina"
            },
            {
                  "name": "Kebbi",
                  "nameAr": "Kebbi",
                  "nameFr": "Kebbi"
            },
            {
                  "name": "Kogi",
                  "nameAr": "Kogi",
                  "nameFr": "Kogi"
            },
            {
                  "name": "Kwara",
                  "nameAr": "Kwara",
                  "nameFr": "Kwara"
            },
            {
                  "name": "Lagos",
                  "nameAr": "Lagos",
                  "nameFr": "Lagos"
            },
            {
                  "name": "Nasarawa",
                  "nameAr": "Nasarawa",
                  "nameFr": "Nasarawa"
            },
            {
                  "name": "Niger",
                  "nameAr": "Niger",
                  "nameFr": "Niger"
            },
            {
                  "name": "Ogun",
                  "nameAr": "Ogun",
                  "nameFr": "Ogun"
            },
            {
                  "name": "Ondo",
                  "nameAr": "Ondo",
                  "nameFr": "Ondo"
            },
            {
                  "name": "Osun",
                  "nameAr": "Osun",
                  "nameFr": "Osun"
            },
            {
                  "name": "Oyo",
                  "nameAr": "Oyo",
                  "nameFr": "Oyo"
            },
            {
                  "name": "Plateau",
                  "nameAr": "Plateau",
                  "nameFr": "Plateau"
            },
            {
                  "name": "Rivers",
                  "nameAr": "Rivers",
                  "nameFr": "Rivers"
            },
            {
                  "name": "Sokoto",
                  "nameAr": "Sokoto",
                  "nameFr": "Sokoto"
            },
            {
                  "name": "Taraba",
                  "nameAr": "Taraba",
                  "nameFr": "Taraba"
            },
            {
                  "name": "Yobe",
                  "nameAr": "Yobe",
                  "nameFr": "Yobe"
            },
            {
                  "name": "Zamfara",
                  "nameAr": "Zamfara",
                  "nameFr": "Zamfara"
            }
      ]
  },
  {
    "code": "RE",
    "name": "Reunion",
    "nameAr": "ريونيون",
    "nameFr": "Reunion",
    "cities": [
            {
                  "name": "Saint-Benoît",
                  "nameAr": "Saint-Benoît",
                  "nameFr": "Saint-Benoît"
            },
            {
                  "name": "Saint-Denis",
                  "nameAr": "Saint-Denis",
                  "nameFr": "Saint-Denis"
            },
            {
                  "name": "Saint-Paul",
                  "nameAr": "Saint-Paul",
                  "nameFr": "Saint-Paul"
            },
            {
                  "name": "Saint-Pierre",
                  "nameAr": "Saint-Pierre",
                  "nameFr": "Saint-Pierre"
            }
      ]
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "nameAr": "رواندا",
    "nameFr": "Rwanda",
    "cities": [
            {
                  "name": "Eastern",
                  "nameAr": "Iburasirazuba",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Kigali",
                  "nameAr": "Kigali",
                  "nameFr": "Kigali"
            },
            {
                  "name": "Northern",
                  "nameAr": "Amajyaruguru",
                  "nameFr": "Northern"
            },
            {
                  "name": "Southern",
                  "nameAr": "Amajyepfo",
                  "nameFr": "Southern"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "SH",
    "name": "Saint Helena",
    "nameAr": "سانت هيلينا",
    "nameFr": "Saint Helena",
    "cities": [
      {
        "name": "Alarm Forest",
        "nameAr": "",
        "nameFr": "Alarm Forest"
      },
      {
        "name": "Blue Hill",
        "nameAr": "",
        "nameFr": "Blue Hill"
      },
      {
        "name": "Half Tree Hollow",
        "nameAr": "",
        "nameFr": "Half Tree Hollow"
      },
      {
        "name": "Jamestown",
        "nameAr": "",
        "nameFr": "Jamestown"
      },
      {
        "name": "Levelwood",
        "nameAr": "",
        "nameFr": "Levelwood"
      },
      {
        "name": "Longwood",
        "nameAr": "",
        "nameFr": "Longwood"
      },
      {
        "name": "Saint Paul's",
        "nameAr": "",
        "nameFr": "Saint Paul's"
      },
      {
        "name": "Sandy Bay",
        "nameAr": "",
        "nameFr": "Sandy Bay"
      }
    ]
  },
  {
    "code": "ST",
    "name": "Sao Tome and Principe",
    "nameAr": "ساو تومي وبرينسيبي",
    "nameFr": "Sao Tome and Principe",
    "cities": [
            {
                  "name": "Príncipe",
                  "nameAr": "Príncipe",
                  "nameFr": "Príncipe"
            },
            {
                  "name": "São Tomé",
                  "nameAr": "São Tomé",
                  "nameFr": "São Tomé"
            }
      ]
  },
  {
    "code": "SN",
    "name": "Senegal",
    "nameAr": "السنغال",
    "nameFr": "Senegal",
    "cities": [
            {
                  "name": "Dakar",
                  "nameAr": "Dakar",
                  "nameFr": "Dakar"
            },
            {
                  "name": "Diourbel Region",
                  "nameAr": "Diourbel Region",
                  "nameFr": "Diourbel Region"
            },
            {
                  "name": "Fatick",
                  "nameAr": "Fatick",
                  "nameFr": "Fatick"
            },
            {
                  "name": "Kaffrine",
                  "nameAr": "Kaffrine",
                  "nameFr": "Kaffrine"
            },
            {
                  "name": "Kaolack",
                  "nameAr": "Kaolack",
                  "nameFr": "Kaolack"
            },
            {
                  "name": "Kédougou",
                  "nameAr": "Kédougou",
                  "nameFr": "Kédougou"
            },
            {
                  "name": "Kolda",
                  "nameAr": "Dans le bras",
                  "nameFr": "Kolda"
            },
            {
                  "name": "Louga",
                  "nameAr": "Lougue",
                  "nameFr": "Louga"
            },
            {
                  "name": "Matam",
                  "nameAr": "doux",
                  "nameFr": "Matam"
            },
            {
                  "name": "Saint-Louis",
                  "nameAr": "Saint-Louis",
                  "nameFr": "Saint-Louis"
            },
            {
                  "name": "Sédhiou",
                  "nameAr": "Sédhiou",
                  "nameFr": "Sédhiou"
            },
            {
                  "name": "Tambacounda Region",
                  "nameAr": "Tambacounda Region",
                  "nameFr": "Tambacounda Region"
            },
            {
                  "name": "Thiès Region",
                  "nameAr": "Thiès Region",
                  "nameFr": "Thiès Region"
            },
            {
                  "name": "Ziguinchor",
                  "nameAr": "Ziguinchor",
                  "nameFr": "Ziguinchor"
            }
      ]
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "nameAr": "سيشل",
    "nameFr": "Seychelles",
    "cities": [
            {
                  "name": "Anse Boileau",
                  "nameAr": "Anse Boileau",
                  "nameFr": "Anse Boileau"
            },
            {
                  "name": "Anse Royale",
                  "nameAr": "Anse Royale",
                  "nameFr": "Anse Royale"
            },
            {
                  "name": "Anse-aux-Pins",
                  "nameAr": "Anse-aux-Pins",
                  "nameFr": "Anse-aux-Pins"
            },
            {
                  "name": "Au Cap",
                  "nameAr": "Au Cap",
                  "nameFr": "Au Cap"
            },
            {
                  "name": "Baie Lazare",
                  "nameAr": "Très lazare",
                  "nameFr": "Baie Lazare"
            },
            {
                  "name": "Baie Sainte Anne",
                  "nameAr": "Baie Sainte Anne",
                  "nameFr": "Baie Sainte Anne"
            },
            {
                  "name": "Beau Vallon",
                  "nameAr": "Beau Vallon",
                  "nameFr": "Beau Vallon"
            },
            {
                  "name": "Bel Air",
                  "nameAr": "Bel Air",
                  "nameFr": "Bel Air"
            },
            {
                  "name": "Bel Ombre",
                  "nameAr": "Belles ombres",
                  "nameFr": "Bel Ombre"
            },
            {
                  "name": "Cascade",
                  "nameAr": "Cascade",
                  "nameFr": "Cascade"
            },
            {
                  "name": "Glacis",
                  "nameAr": "Glacis",
                  "nameFr": "Glacis"
            },
            {
                  "name": "Grand'Anse Mahé",
                  "nameAr": "Grand'Anse Mahé",
                  "nameFr": "Grand'Anse Mahé"
            },
            {
                  "name": "Grand'Anse Praslin",
                  "nameAr": "Grand'Anse Praslin",
                  "nameFr": "Grand'Anse Praslin"
            },
            {
                  "name": "La Digue",
                  "nameAr": "La Digue",
                  "nameFr": "La Digue"
            },
            {
                  "name": "La Rivière Anglaise",
                  "nameAr": "La Rivière Anglaise",
                  "nameFr": "La Rivière Anglaise"
            },
            {
                  "name": "Les Mamelles",
                  "nameAr": "Les Mamelles",
                  "nameFr": "Les Mamelles"
            },
            {
                  "name": "Mont Buxton",
                  "nameAr": "Mont Buxton",
                  "nameFr": "Mont Buxton"
            },
            {
                  "name": "Mont Fleuri",
                  "nameAr": "Mont Fleuri",
                  "nameFr": "Mont Fleuri"
            },
            {
                  "name": "Plaisance",
                  "nameAr": "Plaisance",
                  "nameFr": "Plaisance"
            },
            {
                  "name": "Pointe La Rue",
                  "nameAr": "Pointe La Rue",
                  "nameFr": "Pointe La Rue"
            },
            {
                  "name": "Port Glaud",
                  "nameAr": "Port Glaud",
                  "nameFr": "Port Glaud"
            },
            {
                  "name": "Roche Caiman",
                  "nameAr": "Roche Caiman",
                  "nameFr": "Roche Caiman"
            },
            {
                  "name": "Saint Louis",
                  "nameAr": "Saint Louis",
                  "nameFr": "Saint Louis"
            },
            {
                  "name": "Takamaka",
                  "nameAr": "Takamaka",
                  "nameFr": "Takamaka"
            }
      ]
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "nameAr": "سيراليون",
    "nameFr": "Sierra Leone",
    "cities": [
            {
                  "name": "Eastern",
                  "nameAr": "Eastern",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Northern",
                  "nameAr": "Northern",
                  "nameFr": "Northern"
            },
            {
                  "name": "Southern",
                  "nameAr": "Southern",
                  "nameFr": "Southern"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "SO",
    "name": "Somalia",
    "nameAr": "الصومال",
    "nameFr": "Somalia",
    "cities": [
            {
                  "name": "Awdal",
                  "nameAr": "Awdal",
                  "nameFr": "Awdal"
            },
            {
                  "name": "Bakool",
                  "nameAr": "Bakool",
                  "nameFr": "Bakool"
            },
            {
                  "name": "Banaadir",
                  "nameAr": "Banaadir",
                  "nameFr": "Banaadir"
            },
            {
                  "name": "Bari",
                  "nameAr": "Bari",
                  "nameFr": "Bari"
            },
            {
                  "name": "Bay",
                  "nameAr": "Gacan biyo badda",
                  "nameFr": "Bay"
            },
            {
                  "name": "Galguduud",
                  "nameAr": "Galguduud",
                  "nameFr": "Galguduud"
            },
            {
                  "name": "Gedo",
                  "nameAr": "Gedo",
                  "nameFr": "Gedo"
            },
            {
                  "name": "Hiran",
                  "nameAr": "Hiraan",
                  "nameFr": "Hiran"
            },
            {
                  "name": "Lower Juba",
                  "nameAr": "Jubbada Hoose",
                  "nameFr": "Lower Juba"
            },
            {
                  "name": "Lower Shebelle",
                  "nameAr": "Hoose Shebelle",
                  "nameFr": "Lower Shebelle"
            },
            {
                  "name": "Middle Juba",
                  "nameAr": "Jubbada Dhexe",
                  "nameFr": "Middle Juba"
            },
            {
                  "name": "Middle Shebelle",
                  "nameAr": "Dhexe ee Shebelle",
                  "nameFr": "Middle Shebelle"
            },
            {
                  "name": "Mudug",
                  "nameAr": "Mudug",
                  "nameFr": "Mudug"
            },
            {
                  "name": "Nugal",
                  "nameAr": "Nugal",
                  "nameFr": "Nugal"
            },
            {
                  "name": "Sanaag",
                  "nameAr": "Sanaag",
                  "nameFr": "Sanaag"
            },
            {
                  "name": "Togdheer",
                  "nameAr": "Togdheer",
                  "nameFr": "Togdheer"
            }
      ]
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "nameAr": "جنوب أفريقيا",
    "nameFr": "South Africa",
    "cities": [
            {
                  "name": "Eastern Cape",
                  "nameAr": "Eastern Cape",
                  "nameFr": "Eastern Cape"
            },
            {
                  "name": "Free State",
                  "nameAr": "Free State",
                  "nameFr": "Free State"
            },
            {
                  "name": "Gauteng",
                  "nameAr": "Gauteng",
                  "nameFr": "Gauteng"
            },
            {
                  "name": "KwaZulu-Natal",
                  "nameAr": "KwaZulu-Natal",
                  "nameFr": "KwaZulu-Natal"
            },
            {
                  "name": "Limpopo",
                  "nameAr": "Limpopo",
                  "nameFr": "Limpopo"
            },
            {
                  "name": "Mpumalanga",
                  "nameAr": "East",
                  "nameFr": "Mpumalanga"
            },
            {
                  "name": "North West",
                  "nameAr": "North West",
                  "nameFr": "North West"
            },
            {
                  "name": "Northern Cape",
                  "nameAr": "Northern Cape",
                  "nameFr": "Northern Cape"
            },
            {
                  "name": "Western Cape",
                  "nameAr": "Western Cape",
                  "nameFr": "Western Cape"
            }
      ]
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "nameAr": "جنوب السودان",
    "nameFr": "South Sudan",
    "cities": [
      {
        "name": "Central Equatoria",
        "nameAr": "",
        "nameFr": "Central Equatoria"
      },
      {
        "name": "Eastern Equatoria",
        "nameAr": "",
        "nameFr": "Eastern Equatoria"
      },
      {
        "name": "Jonglei State",
        "nameAr": "",
        "nameFr": "Jonglei State"
      },
      {
        "name": "Lakes",
        "nameAr": "",
        "nameFr": "Lakes"
      },
      {
        "name": "Northern Bahr el Ghazal",
        "nameAr": "",
        "nameFr": "Northern Bahr el Ghazal"
      },
      {
        "name": "Unity",
        "nameAr": "",
        "nameFr": "Unity"
      },
      {
        "name": "Upper Nile",
        "nameAr": "",
        "nameFr": "Upper Nile"
      },
      {
        "name": "Warrap",
        "nameAr": "",
        "nameFr": "Warrap"
      },
      {
        "name": "Western Bahr el Ghazal",
        "nameAr": "",
        "nameFr": "Western Bahr el Ghazal"
      },
      {
        "name": "Western Equatoria",
        "nameAr": "",
        "nameFr": "Western Equatoria"
      }
    ]
  },
  {
    "code": "SD",
    "name": "Sudan",
    "nameAr": "السودان",
    "nameFr": "Sudan",
    "cities": [
            {
                  "name": "Al Jazirah",
                  "nameAr": "Al Jazirah",
                  "nameFr": "Al Jazirah"
            },
            {
                  "name": "Al Qadarif",
                  "nameAr": "Al Qadarif",
                  "nameFr": "Al Qadarif"
            },
            {
                  "name": "Blue Nile",
                  "nameAr": "النيل الأزرق",
                  "nameFr": "Blue Nile"
            },
            {
                  "name": "Central Darfur",
                  "nameAr": "وسط دارفور",
                  "nameFr": "Central Darfur"
            },
            {
                  "name": "East Darfur",
                  "nameAr": "شرق دارفور",
                  "nameFr": "East Darfur"
            },
            {
                  "name": "Kassala",
                  "nameAr": "كاسالا",
                  "nameFr": "Kassala"
            },
            {
                  "name": "Khartoum",
                  "nameAr": "Khartoum",
                  "nameFr": "Khartoum"
            },
            {
                  "name": "North Darfur",
                  "nameAr": "شمال دارفور",
                  "nameFr": "North Darfur"
            },
            {
                  "name": "North Kordofan",
                  "nameAr": "شمال كوردوفان",
                  "nameFr": "North Kordofan"
            },
            {
                  "name": "Northern",
                  "nameAr": "شمالي",
                  "nameFr": "Northern"
            },
            {
                  "name": "Red Sea",
                  "nameAr": "البحر الأحمر",
                  "nameFr": "Red Sea"
            },
            {
                  "name": "River Nile",
                  "nameAr": "نهر النيل",
                  "nameFr": "River Nile"
            },
            {
                  "name": "Sennar",
                  "nameAr": "سنار",
                  "nameFr": "Sennar"
            },
            {
                  "name": "South Darfur",
                  "nameAr": "جنوب دارفور",
                  "nameFr": "South Darfur"
            },
            {
                  "name": "South Kordofan",
                  "nameAr": "جنوب كوردوفان",
                  "nameFr": "South Kordofan"
            },
            {
                  "name": "West Darfur",
                  "nameAr": "غرب دارفور",
                  "nameFr": "West Darfur"
            },
            {
                  "name": "West Kordofan",
                  "nameAr": "غرب كوردوفان",
                  "nameFr": "West Kordofan"
            },
            {
                  "name": "White Nile",
                  "nameAr": "النيل الأبيض",
                  "nameFr": "White Nile"
            }
      ]
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "nameAr": "تنزانيا",
    "nameFr": "Tanzania",
    "cities": [
            {
                  "name": "Arusha",
                  "nameAr": "Arusha",
                  "nameFr": "Arusha"
            },
            {
                  "name": "Dar es Salaam",
                  "nameAr": "Dar ni salaam",
                  "nameFr": "Dar es Salaam"
            },
            {
                  "name": "Dodoma",
                  "nameAr": "Dodoma",
                  "nameFr": "Dodoma"
            },
            {
                  "name": "Geita",
                  "nameAr": "Geita",
                  "nameFr": "Geita"
            },
            {
                  "name": "Iringa",
                  "nameAr": "Iringa",
                  "nameFr": "Iringa"
            },
            {
                  "name": "Kagera",
                  "nameAr": "Kagera",
                  "nameFr": "Kagera"
            },
            {
                  "name": "Katavi",
                  "nameAr": "Katavi",
                  "nameFr": "Katavi"
            },
            {
                  "name": "Kigoma",
                  "nameAr": "Kigoma",
                  "nameFr": "Kigoma"
            },
            {
                  "name": "Kilimanjaro",
                  "nameAr": "Kilimanjaro",
                  "nameFr": "Kilimanjaro"
            },
            {
                  "name": "Lindi",
                  "nameAr": "Lindi",
                  "nameFr": "Lindi"
            },
            {
                  "name": "Manyara",
                  "nameAr": "Manyara",
                  "nameFr": "Manyara"
            },
            {
                  "name": "Mara",
                  "nameAr": "Mara",
                  "nameFr": "Mara"
            },
            {
                  "name": "Mbeya",
                  "nameAr": "Mbeya",
                  "nameFr": "Mbeya"
            },
            {
                  "name": "Morogoro",
                  "nameAr": "Morogoro",
                  "nameFr": "Morogoro"
            },
            {
                  "name": "Mtwara",
                  "nameAr": "Mtwara",
                  "nameFr": "Mtwara"
            },
            {
                  "name": "Mwanza",
                  "nameAr": "Mwanza",
                  "nameFr": "Mwanza"
            },
            {
                  "name": "Njombe",
                  "nameAr": "Njombe",
                  "nameFr": "Njombe"
            },
            {
                  "name": "Pemba North",
                  "nameAr": "Pemba North",
                  "nameFr": "Pemba North"
            },
            {
                  "name": "Pemba South",
                  "nameAr": "Pemba Kusini",
                  "nameFr": "Pemba South"
            },
            {
                  "name": "Pwani",
                  "nameAr": "Pwani",
                  "nameFr": "Pwani"
            },
            {
                  "name": "Rukwa",
                  "nameAr": "Rukwa",
                  "nameFr": "Rukwa"
            },
            {
                  "name": "Ruvuma",
                  "nameAr": "Ruvuma",
                  "nameFr": "Ruvuma"
            },
            {
                  "name": "Shinyanga",
                  "nameAr": "Shinyanga",
                  "nameFr": "Shinyanga"
            },
            {
                  "name": "Simiyu",
                  "nameAr": "Simiyu",
                  "nameFr": "Simiyu"
            },
            {
                  "name": "Singida",
                  "nameAr": "Singida",
                  "nameFr": "Singida"
            },
            {
                  "name": "Songwe",
                  "nameAr": "Songwe",
                  "nameFr": "Songwe"
            },
            {
                  "name": "Tabora",
                  "nameAr": "Tabora",
                  "nameFr": "Tabora"
            },
            {
                  "name": "Tanga",
                  "nameAr": "Tanga",
                  "nameFr": "Tanga"
            },
            {
                  "name": "Zanzibar North",
                  "nameAr": "Zanzibar Kaskazini",
                  "nameFr": "Zanzibar North"
            },
            {
                  "name": "Zanzibar South",
                  "nameAr": "Zanzibar Kusini",
                  "nameFr": "Zanzibar South"
            },
            {
                  "name": "Zanzibar West",
                  "nameAr": "Zanzibar West",
                  "nameFr": "Zanzibar West"
            }
      ]
  },
  {
    "code": "GM",
    "name": "The Gambia",
    "nameAr": "غامبيا",
    "nameFr": "The Gambia",
    "cities": [
            {
                  "name": "Banjul",
                  "nameAr": "Banjul",
                  "nameFr": "Banjul"
            },
            {
                  "name": "Central River",
                  "nameAr": "Central River",
                  "nameFr": "Central River"
            },
            {
                  "name": "Lower River",
                  "nameAr": "Lower River",
                  "nameFr": "Lower River"
            },
            {
                  "name": "North Bank",
                  "nameAr": "North Bank",
                  "nameFr": "North Bank"
            },
            {
                  "name": "Upper River",
                  "nameAr": "Upper River",
                  "nameFr": "Upper River"
            },
            {
                  "name": "West Coast",
                  "nameAr": "West Coast",
                  "nameFr": "West Coast"
            }
      ]
  },
  {
    "code": "TG",
    "name": "Togo",
    "nameAr": "توغو",
    "nameFr": "Togo",
    "cities": [
            {
                  "name": "Centrale",
                  "nameAr": "Central",
                  "nameFr": "Centrale"
            },
            {
                  "name": "Kara",
                  "nameAr": "Kara",
                  "nameFr": "Kara"
            },
            {
                  "name": "Maritime",
                  "nameAr": "Maritime",
                  "nameFr": "Maritime"
            },
            {
                  "name": "Plateaux",
                  "nameAr": "Plateaux",
                  "nameFr": "Plateaux"
            },
            {
                  "name": "Savanes",
                  "nameAr": "Savanes",
                  "nameFr": "Savanes"
            }
      ]
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "nameAr": "تونس",
    "nameFr": "Tunisia",
    "cities": [
            {
                  "name": "Ariana",
                  "nameAr": "أريانا",
                  "nameFr": "Ariana"
            },
            {
                  "name": "Béja",
                  "nameAr": "Béja",
                  "nameFr": "Béja"
            },
            {
                  "name": "Ben Arous",
                  "nameAr": "بن آروس",
                  "nameFr": "Ben Arous"
            },
            {
                  "name": "Bizerte",
                  "nameAr": "بيزرتي",
                  "nameFr": "Bizerte"
            },
            {
                  "name": "Gabès",
                  "nameAr": "غاب",
                  "nameFr": "Gabès"
            },
            {
                  "name": "Gafsa",
                  "nameAr": "GAFSA",
                  "nameFr": "Gafsa"
            },
            {
                  "name": "Jendouba",
                  "nameAr": "جيندوبا",
                  "nameFr": "Jendouba"
            },
            {
                  "name": "Kairouan",
                  "nameAr": "Kairouan",
                  "nameFr": "Kairouan"
            },
            {
                  "name": "Kasserine",
                  "nameAr": "كاسيرين",
                  "nameFr": "Kasserine"
            },
            {
                  "name": "Kebili",
                  "nameAr": "كره",
                  "nameFr": "Kebili"
            },
            {
                  "name": "Kef",
                  "nameAr": "Kef",
                  "nameFr": "Kef"
            },
            {
                  "name": "Mahdia",
                  "nameAr": "مهديا",
                  "nameFr": "Mahdia"
            },
            {
                  "name": "Manouba",
                  "nameAr": "مانوبا",
                  "nameFr": "Manouba"
            },
            {
                  "name": "Medenine",
                  "nameAr": "النحاس",
                  "nameFr": "Medenine"
            },
            {
                  "name": "Monastir",
                  "nameAr": "Monastir",
                  "nameFr": "Monastir"
            },
            {
                  "name": "Nabeul",
                  "nameAr": "نابول",
                  "nameFr": "Nabeul"
            },
            {
                  "name": "Sfax",
                  "nameAr": "SFAX",
                  "nameFr": "Sfax"
            },
            {
                  "name": "Sidi Bouzid",
                  "nameAr": "سيدي بوزيد",
                  "nameFr": "Sidi Bouzid"
            },
            {
                  "name": "Siliana",
                  "nameAr": "سيليان",
                  "nameFr": "Siliana"
            },
            {
                  "name": "Sousse",
                  "nameAr": "سوس",
                  "nameFr": "Sousse"
            },
            {
                  "name": "Tataouine",
                  "nameAr": "Tataouine",
                  "nameFr": "Tataouine"
            },
            {
                  "name": "Tozeur",
                  "nameAr": "توزور",
                  "nameFr": "Tozeur"
            },
            {
                  "name": "Tunis",
                  "nameAr": "تونس",
                  "nameFr": "Tunis"
            },
            {
                  "name": "Zaghouan",
                  "nameAr": "Zaghouan",
                  "nameFr": "Zaghouan"
            }
      ]
  },
  {
    "code": "UG",
    "name": "Uganda",
    "nameAr": "أوغندا",
    "nameFr": "Uganda",
    "cities": [
            {
                  "name": "Abim",
                  "nameAr": "Abim",
                  "nameFr": "Abim"
            },
            {
                  "name": "Adjumani",
                  "nameAr": "Adjumani",
                  "nameFr": "Adjumani"
            },
            {
                  "name": "Agago",
                  "nameAr": "Agago",
                  "nameFr": "Agago"
            },
            {
                  "name": "Alebtong",
                  "nameAr": "Alebtong",
                  "nameFr": "Alebtong"
            },
            {
                  "name": "Amolatar",
                  "nameAr": "Amolatar",
                  "nameFr": "Amolatar"
            },
            {
                  "name": "Amudat",
                  "nameAr": "Amudat",
                  "nameFr": "Amudat"
            },
            {
                  "name": "Amuria",
                  "nameAr": "Briefly",
                  "nameFr": "Amuria"
            },
            {
                  "name": "Amuru",
                  "nameAr": "Birth",
                  "nameFr": "Amuru"
            },
            {
                  "name": "Apac",
                  "nameAr": "Apac",
                  "nameFr": "Apac"
            },
            {
                  "name": "Arua",
                  "nameAr": "Arua",
                  "nameFr": "Arua"
            },
            {
                  "name": "Budaka",
                  "nameAr": "Budak",
                  "nameFr": "Budaka"
            },
            {
                  "name": "Bududa",
                  "nameAr": "Bududa",
                  "nameFr": "Bududa"
            },
            {
                  "name": "Bugiri",
                  "nameAr": "Bugiri",
                  "nameFr": "Bugiri"
            },
            {
                  "name": "Bugweri",
                  "nameAr": "Bugwy",
                  "nameFr": "Bugweri"
            },
            {
                  "name": "Buhweju",
                  "nameAr": "Buhwe",
                  "nameFr": "Buhweju"
            },
            {
                  "name": "Buikwe",
                  "nameAr": "It has been given",
                  "nameFr": "Buikwe"
            },
            {
                  "name": "Bukedea",
                  "nameAr": "Boule",
                  "nameFr": "Bukedea"
            },
            {
                  "name": "Bukomansimbi",
                  "nameAr": "Bukomansimbi",
                  "nameFr": "Bukomansimbi"
            },
            {
                  "name": "Bukwo",
                  "nameAr": "Bukyo",
                  "nameFr": "Bukwo"
            },
            {
                  "name": "Bulambuli",
                  "nameAr": "Ram",
                  "nameFr": "Bulambuli"
            },
            {
                  "name": "Buliisa",
                  "nameAr": "Belies",
                  "nameFr": "Buliisa"
            },
            {
                  "name": "Bundibugyo",
                  "nameAr": "Bundibugyo",
                  "nameFr": "Bundibugyo"
            },
            {
                  "name": "Bunyangabu",
                  "nameAr": "Bunyangabu",
                  "nameFr": "Bunyangabu"
            },
            {
                  "name": "Bushenyi",
                  "nameAr": "Bushenyi",
                  "nameFr": "Bushenyi"
            },
            {
                  "name": "Busia",
                  "nameAr": "Busia",
                  "nameFr": "Busia"
            },
            {
                  "name": "Butaleja",
                  "nameAr": "Business",
                  "nameFr": "Butaleja"
            },
            {
                  "name": "Butambala",
                  "nameAr": "Get the",
                  "nameFr": "Butambala"
            },
            {
                  "name": "Butebo",
                  "nameAr": "Butebo",
                  "nameFr": "Butebo"
            },
            {
                  "name": "Buvuma",
                  "nameAr": "Buvuma",
                  "nameFr": "Buvuma"
            },
            {
                  "name": "Buyende",
                  "nameAr": "Ring",
                  "nameFr": "Buyende"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Dokolo",
                  "nameAr": "DOCTORY",
                  "nameFr": "Dokolo"
            },
            {
                  "name": "Eastern",
                  "nameAr": "Eastern",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Gomba",
                  "nameAr": "Mushroom",
                  "nameFr": "Gomba"
            },
            {
                  "name": "Gulu",
                  "nameAr": "Cavalry",
                  "nameFr": "Gulu"
            },
            {
                  "name": "Hoima",
                  "nameAr": "Hoima",
                  "nameFr": "Hoima"
            },
            {
                  "name": "Ibanda",
                  "nameAr": "Ibanda",
                  "nameFr": "Ibanda"
            },
            {
                  "name": "Iganga",
                  "nameAr": "Iganga",
                  "nameFr": "Iganga"
            },
            {
                  "name": "Isingiro",
                  "nameAr": "Isingiro",
                  "nameFr": "Isingiro"
            },
            {
                  "name": "Jinja",
                  "nameAr": "Jinja",
                  "nameFr": "Jinja"
            },
            {
                  "name": "Kaabong",
                  "nameAr": "Kaabong",
                  "nameFr": "Kaabong"
            },
            {
                  "name": "Kabale",
                  "nameAr": "Cabal",
                  "nameFr": "Kabale"
            },
            {
                  "name": "Kabarole",
                  "nameAr": "Kabarole",
                  "nameFr": "Kabarole"
            },
            {
                  "name": "Kaberamaido",
                  "nameAr": "Kaberamaido",
                  "nameFr": "Kaberamaido"
            },
            {
                  "name": "Kagadi",
                  "nameAr": "Kagadi",
                  "nameFr": "Kagadi"
            },
            {
                  "name": "Kakumiro",
                  "nameAr": "Kakumiro",
                  "nameFr": "Kakumiro"
            },
            {
                  "name": "Kalaki",
                  "nameAr": "Kalaki",
                  "nameFr": "Kalaki"
            },
            {
                  "name": "Kalangala",
                  "nameAr": "Kalangala",
                  "nameFr": "Kalangala"
            },
            {
                  "name": "Kaliro",
                  "nameAr": "Kaliro",
                  "nameFr": "Kaliro"
            },
            {
                  "name": "Kalungu",
                  "nameAr": "Kalungu",
                  "nameFr": "Kalungu"
            },
            {
                  "name": "Kampala",
                  "nameAr": "Kampala",
                  "nameFr": "Kampala"
            },
            {
                  "name": "Kamuli",
                  "nameAr": "Kamuli",
                  "nameFr": "Kamuli"
            },
            {
                  "name": "Kamwenge",
                  "nameAr": "Kamwenge",
                  "nameFr": "Kamwenge"
            },
            {
                  "name": "Kanungu",
                  "nameAr": "Kanungu",
                  "nameFr": "Kanungu"
            },
            {
                  "name": "Kapchorwa",
                  "nameAr": "Kapchorwa",
                  "nameFr": "Kapchorwa"
            },
            {
                  "name": "Kapelebyong",
                  "nameAr": "Kapelebong",
                  "nameFr": "Kapelebyong"
            },
            {
                  "name": "Karenga",
                  "nameAr": "Karenga",
                  "nameFr": "Karenga"
            },
            {
                  "name": "Kasanda",
                  "nameAr": "Kasanda",
                  "nameFr": "Kasanda"
            },
            {
                  "name": "Kasese",
                  "nameAr": "Kasese",
                  "nameFr": "Kasese"
            },
            {
                  "name": "Katakwi",
                  "nameAr": "Katakwi",
                  "nameFr": "Katakwi"
            },
            {
                  "name": "Kayunga",
                  "nameAr": "Kayunga",
                  "nameFr": "Kayunga"
            },
            {
                  "name": "Kazo",
                  "nameAr": "A tree",
                  "nameFr": "Kazo"
            },
            {
                  "name": "Kibaale",
                  "nameAr": "Kibaale",
                  "nameFr": "Kibaale"
            },
            {
                  "name": "Kiboga",
                  "nameAr": "Kiboga",
                  "nameFr": "Kiboga"
            },
            {
                  "name": "Kibuku",
                  "nameAr": "Kibuku",
                  "nameFr": "Kibuku"
            },
            {
                  "name": "Kikuube",
                  "nameAr": "It's 100%",
                  "nameFr": "Kikuube"
            },
            {
                  "name": "Kiruhura",
                  "nameAr": "KirUhura",
                  "nameFr": "Kiruhura"
            },
            {
                  "name": "Kiryandongo",
                  "nameAr": "Kiryandongo",
                  "nameFr": "Kiryandongo"
            },
            {
                  "name": "Kisoro",
                  "nameAr": "Kisoro",
                  "nameFr": "Kisoro"
            },
            {
                  "name": "Kitagwenda",
                  "nameAr": "Kitagwenda",
                  "nameFr": "Kitagwenda"
            },
            {
                  "name": "Kitgum",
                  "nameAr": "Kitgum",
                  "nameFr": "Kitgum"
            },
            {
                  "name": "Koboko",
                  "nameAr": "Koboko",
                  "nameFr": "Koboko"
            },
            {
                  "name": "Kole",
                  "nameAr": "Kole",
                  "nameFr": "Kole"
            },
            {
                  "name": "Kotido",
                  "nameAr": "Cotido",
                  "nameFr": "Kotido"
            },
            {
                  "name": "Kumi",
                  "nameAr": "Kumi",
                  "nameFr": "Kumi"
            },
            {
                  "name": "Kwania",
                  "nameAr": "For",
                  "nameFr": "Kwania"
            },
            {
                  "name": "Kween",
                  "nameAr": "Kween",
                  "nameFr": "Kween"
            },
            {
                  "name": "Kyankwanzi",
                  "nameAr": "Clean",
                  "nameFr": "Kyankwanzi"
            },
            {
                  "name": "Kyegegwa",
                  "nameAr": "Kyegegwa",
                  "nameFr": "Kyegegwa"
            },
            {
                  "name": "Kyenjojo",
                  "nameAr": "KYANJOJO",
                  "nameFr": "Kyenjojo"
            },
            {
                  "name": "Kyotera",
                  "nameAr": "Kyotera",
                  "nameFr": "Kyotera"
            },
            {
                  "name": "Lamwo",
                  "nameAr": "Lamwo",
                  "nameFr": "Lamwo"
            },
            {
                  "name": "Lira",
                  "nameAr": "Lira",
                  "nameFr": "Lira"
            },
            {
                  "name": "Luuka",
                  "nameAr": "Bone",
                  "nameFr": "Luuka"
            },
            {
                  "name": "Luwero",
                  "nameAr": "Seaweed",
                  "nameFr": "Luwero"
            },
            {
                  "name": "Lwengo",
                  "nameAr": "Lwengo",
                  "nameFr": "Lwengo"
            },
            {
                  "name": "Lyantonde",
                  "nameAr": "Lyantonde",
                  "nameFr": "Lyantonde"
            },
            {
                  "name": "Madi-Okollo",
                  "nameAr": "Madi-Ooklo",
                  "nameFr": "Madi-Okollo"
            },
            {
                  "name": "Manafwa",
                  "nameAr": "Inhanish",
                  "nameFr": "Manafwa"
            },
            {
                  "name": "Maracha",
                  "nameAr": "Maracha",
                  "nameFr": "Maracha"
            },
            {
                  "name": "Masaka",
                  "nameAr": "Masaka",
                  "nameFr": "Masaka"
            },
            {
                  "name": "Masindi",
                  "nameAr": "Masindi",
                  "nameFr": "Masindi"
            },
            {
                  "name": "Mayuge",
                  "nameAr": "Mayuge",
                  "nameFr": "Mayuge"
            },
            {
                  "name": "Mbale",
                  "nameAr": "Dish",
                  "nameFr": "Mbale"
            },
            {
                  "name": "Mbarara",
                  "nameAr": "Robbery",
                  "nameFr": "Mbarara"
            },
            {
                  "name": "Mitooma",
                  "nameAr": "Micooma",
                  "nameFr": "Mitooma"
            },
            {
                  "name": "Mityana",
                  "nameAr": "Mityana",
                  "nameFr": "Mityana"
            },
            {
                  "name": "Moroto",
                  "nameAr": "Moroto",
                  "nameFr": "Moroto"
            },
            {
                  "name": "Moyo",
                  "nameAr": "Moyo",
                  "nameFr": "Moyo"
            },
            {
                  "name": "Mpigi",
                  "nameAr": "Mpigi",
                  "nameFr": "Mpigi"
            },
            {
                  "name": "Mubende",
                  "nameAr": "The Valley",
                  "nameFr": "Mubende"
            },
            {
                  "name": "Mukono",
                  "nameAr": "Mukono",
                  "nameFr": "Mukono"
            },
            {
                  "name": "Nabilatuk",
                  "nameAr": "Nabilatuk",
                  "nameFr": "Nabilatuk"
            },
            {
                  "name": "Nakapiripirit",
                  "nameAr": "Nakapiripirit Nakapiripirit",
                  "nameFr": "Nakapiripirit"
            },
            {
                  "name": "Nakaseke",
                  "nameAr": "Nakaseke",
                  "nameFr": "Nakaseke"
            },
            {
                  "name": "Nakasongola",
                  "nameAr": "Nakasongola",
                  "nameFr": "Nakasongola"
            },
            {
                  "name": "Namayingo",
                  "nameAr": "Namayingo",
                  "nameFr": "Namayingo"
            },
            {
                  "name": "Namisindwa",
                  "nameAr": "Namisindwa",
                  "nameFr": "Namisindwa"
            },
            {
                  "name": "Namutumba",
                  "nameAr": "Namutumba",
                  "nameFr": "Namutumba"
            },
            {
                  "name": "Napak",
                  "nameAr": "Mistakes",
                  "nameFr": "Napak"
            },
            {
                  "name": "Nebbi",
                  "nameAr": "Nebbi",
                  "nameFr": "Nebbi"
            },
            {
                  "name": "Ngora",
                  "nameAr": "Ngora",
                  "nameFr": "Ngora"
            },
            {
                  "name": "Northern",
                  "nameAr": "Northern",
                  "nameFr": "Northern"
            },
            {
                  "name": "Ntoroko",
                  "nameAr": "Nghoroko",
                  "nameFr": "Ntoroko"
            },
            {
                  "name": "Ntungamo",
                  "nameAr": "Ntungamo",
                  "nameFr": "Ntungamo"
            },
            {
                  "name": "Nwoya",
                  "nameAr": "Nwoya",
                  "nameFr": "Nwoya"
            },
            {
                  "name": "Obongi",
                  "nameAr": "You are right",
                  "nameFr": "Obongi"
            },
            {
                  "name": "Omoro",
                  "nameAr": "Omoro",
                  "nameFr": "Omoro"
            },
            {
                  "name": "Otuke",
                  "nameAr": "Otuke",
                  "nameFr": "Otuke"
            },
            {
                  "name": "Oyam",
                  "nameAr": "Oyam",
                  "nameFr": "Oyam"
            },
            {
                  "name": "Pader",
                  "nameAr": "Wall",
                  "nameFr": "Pader"
            },
            {
                  "name": "Pakwach",
                  "nameAr": "Pakwach",
                  "nameFr": "Pakwach"
            },
            {
                  "name": "Pallisa",
                  "nameAr": "Pallisa",
                  "nameFr": "Pallisa"
            },
            {
                  "name": "Rakai",
                  "nameAr": "Rakai",
                  "nameFr": "Rakai"
            },
            {
                  "name": "Rubanda",
                  "nameAr": "Public",
                  "nameFr": "Rubanda"
            },
            {
                  "name": "Rubirizi",
                  "nameAr": "Rubirizi",
                  "nameFr": "Rubirizi"
            },
            {
                  "name": "Rukiga",
                  "nameAr": "Rukiga",
                  "nameFr": "Rukiga"
            },
            {
                  "name": "Rukungiri",
                  "nameAr": "Rukungiri",
                  "nameFr": "Rukungiri"
            },
            {
                  "name": "Rwampara",
                  "nameAr": "Rwampara",
                  "nameFr": "Rwampara"
            },
            {
                  "name": "Sembabule",
                  "nameAr": "Sembabule",
                  "nameFr": "Sembabule"
            },
            {
                  "name": "Serere",
                  "nameAr": "Serene",
                  "nameFr": "Serere"
            },
            {
                  "name": "Sheema",
                  "nameAr": "Sheema",
                  "nameFr": "Sheema"
            },
            {
                  "name": "Sironko",
                  "nameAr": "Sironko",
                  "nameFr": "Sironko"
            },
            {
                  "name": "Soroti",
                  "nameAr": "Soroti",
                  "nameFr": "Soroti"
            },
            {
                  "name": "Tororo",
                  "nameAr": "Tororo",
                  "nameFr": "Tororo"
            },
            {
                  "name": "Wakiso",
                  "nameAr": "Wakiso",
                  "nameFr": "Wakiso"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            },
            {
                  "name": "Yumbe",
                  "nameAr": "Hello",
                  "nameFr": "Yumbe"
            },
            {
                  "name": "Zombo",
                  "nameAr": "Vertical",
                  "nameFr": "Zombo"
            }
      ]
  },
  {
    "code": "EH",
    "name": "Western Sahara",
    "nameAr": "الصحراء الغربية",
    "nameFr": "Western Sahara",
    "cities": []
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "nameAr": "زامبيا",
    "nameFr": "Zambia",
    "cities": [
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Copperbelt",
                  "nameAr": "Copperbelt",
                  "nameFr": "Copperbelt"
            },
            {
                  "name": "Eastern",
                  "nameAr": "Eastern",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Luapula",
                  "nameAr": "Luapula",
                  "nameFr": "Luapula"
            },
            {
                  "name": "Lusaka",
                  "nameAr": "Saturday",
                  "nameFr": "Lusaka"
            },
            {
                  "name": "Muchinga",
                  "nameAr": "To go",
                  "nameFr": "Muchinga"
            },
            {
                  "name": "Northern",
                  "nameAr": "Northern",
                  "nameFr": "Northern"
            },
            {
                  "name": "Northwestern",
                  "nameAr": "Northwestern",
                  "nameFr": "Northwestern"
            },
            {
                  "name": "Southern",
                  "nameAr": "Southern",
                  "nameFr": "Southern"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "nameAr": "زيمبابوي",
    "nameFr": "Zimbabwe",
    "cities": [
            {
                  "name": "Bulawayo",
                  "nameAr": "Bulawayo",
                  "nameFr": "Bulawayo"
            },
            {
                  "name": "Harare",
                  "nameAr": "Harare",
                  "nameFr": "Harare"
            },
            {
                  "name": "Manicaland",
                  "nameAr": "Manicaland",
                  "nameFr": "Manicaland"
            },
            {
                  "name": "Mashonaland Central",
                  "nameAr": "Mashonaland Central",
                  "nameFr": "Mashonaland Central"
            },
            {
                  "name": "Mashonaland East",
                  "nameAr": "Mashonaland East",
                  "nameFr": "Mashonaland East"
            },
            {
                  "name": "Mashonaland West",
                  "nameAr": "Mashonaland West",
                  "nameFr": "Mashonaland West"
            },
            {
                  "name": "Masvingo",
                  "nameAr": "Masvingo",
                  "nameFr": "Masvingo"
            },
            {
                  "name": "Matabeleland North",
                  "nameAr": "Matabeleland North",
                  "nameFr": "Matabeleland North"
            },
            {
                  "name": "Matabeleland South",
                  "nameAr": "Matabeleland South",
                  "nameFr": "Matabeleland South"
            },
            {
                  "name": "Midlands",
                  "nameAr": "Midlands",
                  "nameFr": "Midlands"
            }
      ]
  }
];
